/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B020010 売上入力
 */

import { Column } from "@material-table/core";
import { Box } from "@mui/system";
import Big, { RoundingMode } from "big.js";
import {
  B000111Biko,
  B000111DenpyoshubetsuNmAndTenpudenpyo,
  B000111Meisaibiko,
  B000111TenpudenpyoNmByDenpyoshubetsu,
  B000111UnsogaishaNm,
  B000140AssistantNm,
  B000140Shain,
  B000190SokoNmSokoshubetsuKbn,
  B010010Nonyu,
  B020010Create,
  B020010HandleChangeJanCd,
  B020010HandleChangeShohinCd,
  B020010Kanosu,
  B020010Shohin,
  B020010TankaList,
  B020010Tokui,
  B020010Update,
  B020010WhTanka,
  B020010ZeiRitsu,
  B020020GetResponse,
  catchRestError,
  B020010ShohinZaiko,
  B020010Tanka,
  B020010UchiwakeKbn,
} from "clients/rest";
import {
  msgState,
  SCancelButton,
  SCodeSelect,
  SConfirmDialogAction,
  SDateField,
  SEntryTab,
  SFrame,
  SInfoButton,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientError, getClientMessage } from "messages";
import {
  ChohaKbn,
  DenpyoHakoKbn,
  getSCode,
  HasokbnCd,
  HasosakiCd,
  HyoziKazeiKbn,
  JuchuSeisanhinKbn,
  SCode,
  SeikyusyoHakoKbn,
  UriageUchiwakeKbn,
  ZeiKbn,
} from "messages/codes";
import { labels } from "messages/labels";
import {
  B000111,
  B000140,
  B000150,
  B000151,
  B000190,
  B000200,
  B000220,
  B020011,
} from "pages";
import { createRef, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { date, dateAt, validDate } from "services";
import {
  digit,
  getHitsuyosu,
  getJodaitanka,
  getJuchuKin,
  getJuchutanka,
  getKakeritsu,
  getUchizeiJuchutanka,
} from "services/CalcService";
import {
  editKbn,
  juchuSeisanhinKbn,
  meishoKbn,
  setshohinKbn,
  shohinShokuchiKbn,
  shohinshubetsuKbn,
  shokuchiKbn,
  sokoshubetsuKbn,
  tankaKbn,
  tenyuryokujodaiKbn,
  tenyuryokuuriKbn,
  uriagesakuseiKbn,
  zaikokanriKbn,
  zeiKbn,
  zeimarumeKbn,
} from "services/codes";
import { focusState, useFocus } from "states";
import { B020012, B020012Props } from "./B020012";

// TODO: 詳細設計 明細フィールド カラムID[sokoshubetsu_kbn]がスネークケースになっている
// TODO: tokuizipCd等の項目をDBに合わせた変数名にしたい(受注入力も)

export type B020010InputData = {
  editKbn: string;
  uriage: B020020GetResponse;
};

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// フィールド定義
type Fields = Partial<{
  editKbn: string;
  uridenpyohakoKbn: SCode;
  uridenpyoNo: string;
  senyodenpyoNo: string;
  juchudenpyoNo: string;
  uriageKbn: SCode;
  tankaKakeritsu: string;
  zeimarumeKbn: number;
  kinmarumeKbn: number;
  tokuiShokuchiKbn: number;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  tokuiPostCd: string;
  tokuiAddress1: string;
  tokuiAddress2: string;
  tokuiTelNo: string;
  tokuiFaxNo: string;
  denpyogyosu: number;
  shimeD: string;
  shainCd: string;
  shainNm: string;
  nonyuShokuchiKbn: number;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  nonyuPostCd: string;
  nonyuAddress1: string;
  nonyuAddress2: string;
  nonyuTelNo: string;
  nonyuFaxNo: string;
  eigyoCd: string;
  uriYmd: string | null;
  shukaYmd: string | null;
  hasosakiCd: SCode;
  hasokbnCd: SCode;
  seikyushokisaiKbn: SCode;
  zeiKbnView: SCode;
  zeiKbn: string;
  assistantCd: string;
  assistantNm: string;
  denpyoshubetsuCd: string;
  denpyoshubetsuNm: string;
  tenpudenpyoCd: string;
  tenpudenpyoNm: string;
  bunrui: string;
  unsogaishaCd: string;
  unsogaishaNm: string;
  bumonCd: string;
  bumonNm: string;
  chumonNo: string;
  denpyoKbn: string;
  ritsu: string;
  hinbetsuNo: string;
  tantosha: string;
  bikoCd: string;
  biko: string;
  bikoCdBefore: string;
  nohinsaki: string;
  uribaNm: string;
  naisen: string;
  uriKinGokei: string;
  zeiGokei: string;
  denpyoGokei: string;
  ediKbn: string;
  ediMemo: string;
  zeiRitsu: string;
  version: string;
  uriageSakuseiKbn: number;
  jodaihyojiKbn: string;
  tankamarumeKbn: string;
  tankahasuichi: string;
  dirtyFields: {
    tokuiCd: string;
    tokuishitenCd: string;
    nonyuCd: string;
    nonyushitenCd: string;
    shainCd: string;
    assistantCd: string;
    denpyoshubetsuCd: string;
    tenpudenpyoCd: string;
    unsogaishaCd: string;
    uriYmd: string;
  };
}>;

//明細入力部
export type UriMeiFields = MeiData &
  Partial<{
    meiTab: boolean;
    dirtyFields: {
      shohinCd: string;
      janCd: string;
      sokoCd: string;
      sotosunW: string;
      sotosunH: string;
      urisu: string;
      jodaitanka: string;
      uritanka: string;
      kakeritsu: string;
    };
  }>;

// 明細データ
type MeiData = Partial<{
  uridenpyoNo: string;
  urigyoNo: number;
  juchudenpyoNo: string;
  juchugyoNo: string;
  uchiwakeKbn: SCode;
  kasanfugo: number;
  juchuSeisanhinKbn: SCode;
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  sokoCd: string;
  shohinCdBefore: string;
  sokoNm: string;
  sokoshubetsuKbn: number;
  aiteCd: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  vol: string;
  urisu: string;
  nebikiUrisu: string;
  urisuBefore: string;
  kanosu: string;
  tenyuryokujodaiKbn: number;
  tenyuryokuuriKbn: number;
  basejodaitanka: string;
  baseuritanka: string;
  kazei: SCode;
  genkatanka: string;
  genkaKin: string;
  jodaiKin: string;
  jodaitanka: string;
  uritanka: string;
  zeinukiuritanka: string;
  zeinukiuriKin: string;
  uchizeiKin: string;
  sotozeiKin: string;
  kakeritsu: string;
  uriKin: string;
  meisaibikoCd: string;
  meisaibikoCdBefore: string;
  meisaibiko: string;
  kazeiKbnView: string;
  kazeiKbn: number;
  setshohinKbn: number;
  crtDate: string;
  crtshainCd: string;
  shohinshubetsuKbn: number;
  tankaKbn: number;
  shokuchiKbn: number;
  whtankaCd: string;
  zaikokanriKbn: number;
  koseiData: KoseiData[];
}>;

// セット構成品データ定義
type KoseiData = Partial<{
  uridenpyoNo: string;
  urigyoNo: number;
  urikoseigyoNo: number;
  juchudenpyoNo: string;
  juchugyoNo: string;
  juchukoseigyoNo: string;
  shohinCd: string;
  shohinCdBefore: string;
  sokoCd: string;
  shohinNm: string;
  janCd: string;
  aiteCd: string;
  koseisu: string;
  hitsuyosu: string;
  hitsuyosuBefore: string;
  kanosu: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  tenyuryokujodaiKbn: number;
  tenyuryokuuriKbn: number;
  basejodaitanka: string;
  baseuritanka: string;
  jodaitanka: string;
  uritanka: string;
  kakeritsu: string;
  uriKin: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  kazeiKbn: number;
  shohinshubetsuKbn: number;
  tankaKbn: number;
  shokuchiKbn: number;
  whtankaCd: string;
  setshohinKbn: number;
  zaikokanriKbn: number;
  crtDate: string;
  crtshainCd: string;
}>;

// 明細テーブルデータ定義
type Data = Partial<{
  uridenpyoNo: string;
  urigyoNo: number;
  juchudenpyoNo: string;
  juchugyoNo: string;
  uchiwakeKbnView: string;
  uchiwakeKbn: string;
  kasanfugo: number;
  juchuSeisanhinKbnView: string;
  juchuSeisanhinKbn: string;
  shohinCd: string;
  shohinCdBefore: string;
  janCd: string;
  aiteCd: string;
  shohinNm: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  urisu: string;
  urisuBefore: string;
  kanosu: string;
  tenyuryokujodaiKbn: number;
  tenyuryokuuriKbn: number;
  basejodaitanka: string;
  baseuritanka: string;
  jodaitanka: string;
  uritanka: string;
  kakeritsu: string;
  uriKin: string;
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: number;
  meisaibikoCd: string;
  meisaibiko: string;
  kazeiKbnView: string;
  kazeiKbn: number;
  setshohinKbn: number;
  shokuchiKbn: number;
  crtDate: string;
  crtshainCd: string;
  shohinshubetsuKbn: number;
  tankaKbn: number;
  whtankaCd: string;
  zaikokanriKbn: number;
  koseiData: KoseiData[];
}>;

// フィールド初期値
const defaultFields: Fields = {
  editKbn: editKbn.register,
  uridenpyohakoKbn: getSCode(DenpyoHakoKbn, "0"),
  uridenpyoNo: "",
  senyodenpyoNo: "",
  juchudenpyoNo: "",
  uriageKbn: getSCode(ChohaKbn, "0"),
  tankaKakeritsu: "",
  zeimarumeKbn: undefined,
  kinmarumeKbn: undefined,
  tokuiShokuchiKbn: undefined,
  tokuiCd: "",
  tokuishitenCd: "",
  tokuiNm: "",
  tokuiPostCd: "",
  tokuiAddress1: "",
  tokuiAddress2: "",
  tokuiTelNo: "",
  tokuiFaxNo: "",
  denpyogyosu: undefined,
  shimeD: "",
  shainCd: "",
  shainNm: "",
  nonyuShokuchiKbn: undefined,
  nonyuCd: "",
  nonyushitenCd: "",
  nonyuNm: "",
  nonyuPostCd: "",
  nonyuAddress1: "",
  nonyuAddress2: "",
  nonyuTelNo: "",
  nonyuFaxNo: "",
  eigyoCd: "",
  uriYmd: date(),
  shukaYmd: null,
  hasosakiCd: getSCode(HasosakiCd, "0"),
  hasokbnCd: getSCode(HasokbnCd, "0"),
  seikyushokisaiKbn: getSCode(SeikyusyoHakoKbn, "1"),
  zeiKbnView: getSCode(ZeiKbn, ""),
  zeiKbn: "",
  assistantCd: "",
  assistantNm: "",
  denpyoshubetsuCd: "",
  denpyoshubetsuNm: "",
  tenpudenpyoCd: "",
  tenpudenpyoNm: "",
  bunrui: "",
  unsogaishaCd: "",
  unsogaishaNm: "",
  bumonCd: "",
  bumonNm: "",
  chumonNo: "",
  denpyoKbn: "",
  ritsu: "",
  hinbetsuNo: "",
  tantosha: "",
  bikoCd: "",
  biko: "",
  bikoCdBefore: "",
  nohinsaki: "",
  uribaNm: "",
  naisen: "",
  uriKinGokei: "",
  zeiGokei: "",
  denpyoGokei: "",
  ediKbn: "",
  ediMemo: "",
  zeiRitsu: "",
  jodaihyojiKbn: "",
  version: "",
  tankamarumeKbn: "",
  tankahasuichi: "",
  uriageSakuseiKbn: uriagesakuseiKbn.new,
  dirtyFields: {
    tokuiCd: "",
    tokuishitenCd: "",
    nonyuCd: "",
    nonyushitenCd: "",
    shainCd: "",
    assistantCd: "",
    denpyoshubetsuCd: "",
    tenpudenpyoCd: "",
    unsogaishaCd: "",
    uriYmd: date(),
  },
};

// 明細フィールド初期値
const meiDefaultFields: UriMeiFields = {
  meiTab: true,
  dirtyFields: {
    shohinCd: "",
    janCd: "",
    sokoCd: "",
    sotosunW: "",
    sotosunH: "",
    urisu: "",
    jodaitanka: "",
    uritanka: "",
    kakeritsu: "",
  },
  uridenpyoNo: "",
  urigyoNo: undefined,
  juchudenpyoNo: "",
  juchugyoNo: "",
  uchiwakeKbn: getSCode(UriageUchiwakeKbn, "0"),
  kasanfugo: undefined,
  juchuSeisanhinKbn: getSCode(JuchuSeisanhinKbn, juchuSeisanhinKbn.nashi),
  shohinCd: "",
  shohinCdBefore: "",
  janCd: "",
  shohinNm: "",
  sokoCd: "",
  sokoNm: "",
  aiteCd: "",
  sotosunW: "",
  sotosunH: "",
  uchisunW: "",
  uchisunH: "",
  vol: "",
  urisu: "",
  nebikiUrisu: "",
  urisuBefore: "",
  kanosu: "",
  tenyuryokujodaiKbn: undefined,
  tenyuryokuuriKbn: undefined,
  basejodaitanka: "",
  baseuritanka: "",
  kazei: getSCode(HyoziKazeiKbn, ""),
  genkatanka: "",
  genkaKin: "",
  jodaiKin: "",
  jodaitanka: "",
  uritanka: "",
  zeinukiuritanka: "",
  zeinukiuriKin: "",
  uchizeiKin: "",
  sotozeiKin: "",
  kakeritsu: "",
  uriKin: "",
  meisaibikoCd: "",
  meisaibikoCdBefore: "",
  meisaibiko: "",
  kazeiKbnView: "",
  kazeiKbn: undefined,
  setshohinKbn: undefined,
  crtDate: "",
  crtshainCd: "",
  shohinshubetsuKbn: undefined,
  tankaKbn: undefined,
  shokuchiKbn: undefined,
  whtankaCd: "",
  zaikokanriKbn: undefined,
  koseiData: [],
};

// テーブル設定
const columns: Column<Data>[] = [
  { field: "uridenpyoNo", title: "売上伝票番号", hidden: true },
  { field: "juchudenpyoNo", title: "受注伝票番号", hidden: true },
  { field: "juchugyoNo", title: "受注行番号", hidden: true },
  { field: "urigyoNo", title: "行　", width: "4rem", align: "right" },
  {
    field: "uchiwakeKbnView",
    title: "区分",
    width: "5rem",
    render: (data) => {
      return getSCode(UriageUchiwakeKbn, data.uchiwakeKbn ?? "0")?.label;
    },
  },
  { field: "uchiwakeKbn", title: "内訳区分", hidden: true },
  { field: "juchuSeisanhinKbnView", title: "受注生産品", width: "5rem" },
  {
    field: "juchuSeisanhinKbn",
    title: "受注生産品",
    hidden: true,
  },
  { field: "juchuSeisanhinKbn", title: "予約区分", hidden: true },
  { field: "shohinCd", title: "商品コード", width: "7rem" },
  { field: "shohinCdBefore", title: "商品コード(変更前)", hidden: true },
  { field: "janCd", title: "JAN コード", hidden: true },
  { field: "aiteCd", title: "相手コード", width: "7rem" },
  { field: "shohinNm", title: "商品名", width: "10rem" },
  { field: "vol", title: "VOL", width: "4rem" },
  { field: "sotosunW", title: "外幅", hidden: true },
  { field: "sotosunH", title: "外高さ", hidden: true },
  { field: "uchisunW", title: "内幅", hidden: true },
  { field: "uchisunH", title: "内高さ", hidden: true },
  {
    field: "urisu",
    title: "売上数　",
    align: "right",
    width: "4rem",
    render: (data) => {
      if (Number(data.uchiwakeKbn) !== uchiwakeKbnNebiki) {
        return digit(data.urisu);
      }
    },
  },
  { field: "nebikiUrisu", hidden: true },
  { field: "urisuBefore", title: "売上数(変更前)", hidden: true },
  {
    field: "kanosu",
    title: "可能数　",
    align: "right",
    width: "4rem",
    render: (data) => digit(data.kanosu),
  },
  { field: "tenyuryokujodaiKbn", title: "手入力上代区分", hidden: true },
  { field: "tenyuryokuuriKbn", title: "手入力受注区分", hidden: true },
  {
    field: "jodaitanka",
    title: "上代　",
    width: "4rem",
    align: "right",
    render: (data) => {
      let backgroundColor = "inherit";
      if (data.tenyuryokujodaiKbn === tenyuryokujodaiKbn.exists) {
        backgroundColor = "#FFFF00";
      }
      return <Box sx={{ backgroundColor }}>{digit(data.jodaitanka)}</Box>;
    },
  },
  {
    field: "uritanka",
    title: "下代　",
    width: "4rem",
    align: "right",
    render: (data) => {
      let backgroundColor = "inherit";
      if (data.tenyuryokuuriKbn === tenyuryokuuriKbn.exists) {
        backgroundColor = "#FFFF00";
      }
      return <Box sx={{ backgroundColor }}>{digit(data.uritanka)}</Box>;
    },
  },
  { field: "kakeritsu", title: "掛率", align: "right", width: "4rem" },
  {
    field: "uriKin",
    title: "売上金額　",
    align: "right",
    width: "5rem",
    render: (data) => digit(data.uriKin),
  },
  { field: "sokoCd", title: "倉庫コード", width: "5rem" },
  { field: "sokoNm", title: "", width: "6rem" },
  { field: "sokoshubetsuKbn", title: "倉庫種別", hidden: true },
  { field: "meisaibikoCd", title: "明細備考コード", hidden: true },
  { field: "meisaibiko", title: "売上明細備考", width: "12rem" },
  {
    field: "kazeiKbnView",
    title: "税",
    width: "4rem",
    render: (data) => getSCode(HyoziKazeiKbn, data.kazeiKbn ?? "")?.label,
  },
  { field: "kazeiKbn", title: "税区分", hidden: true },
  { field: "setshohinKbn", title: "セット商品区分", hidden: true },
  { field: "shokuchiKbn", title: "諸口区分", hidden: true },
  { field: "crtDate", title: "登録日付", hidden: true },
  { field: "crtshainCd", title: "登録社員コード", hidden: true },
  { field: "shohinshubetsuKbn", title: "商品種別区分", hidden: true },
  { field: "tankaKbn", title: "単価区分", hidden: true },
  { field: "whtankaCd", title: "WH単価コード", hidden: true },
  { field: "zaikokanriKbn", title: "在庫管理区分", hidden: true },
];

// 固定値
// 内訳区分(通常)
const uchiwakeKbnTujo: string[] = ["0", "1", "2", "3", "4", "5"];
// 内訳区分(返品)
const uchiwakeKbnHenpin: string[] = ["10", "11", "12", "13", "14", "15"];
const jodaitankaMaxLength: number = 9;
const uritankaMaxLength: number = 9;
const urisuThreshold: number = 0;
const whMin: number = 1;

// 加算符号の値
const kasanfugoPlus: number = 1;
const kasanfugoMinus: number = -1;

// 内訳区分「2:値引き」
const uchiwakeKbnNebiki: number = 2;

const focusId = "B020010";

const torihikishuryoYmd = date();

// B020010 売上入力
export const B020010 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};
const Page = (props: Props) => {
  // 初期設定
  // テーブル管理
  const tableRef = createRef();
  const [rows, setRows] = useState<Data[]>([]);
  const [rowCount, setRowCount] = useState(0);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  const meiMethods = useForm<UriMeiFields>({
    mode: "onBlur",
    defaultValues: meiDefaultFields,
  });

  // dirtyFields初期化
  const resetDirtyFields = () => {
    const fields = methods.getValues();
    methods.setValue("dirtyFields.tokuiCd", fields.tokuiCd ?? "");
    methods.setValue("dirtyFields.tokuishitenCd", fields.tokuishitenCd ?? "");
    methods.setValue("dirtyFields.nonyuCd", fields.nonyuCd ?? "");
    methods.setValue("dirtyFields.nonyushitenCd", fields.nonyushitenCd ?? "");
    methods.setValue("dirtyFields.shainCd", fields.shainCd ?? "");
    methods.setValue("dirtyFields.assistantCd", fields.assistantCd ?? "");
    methods.setValue(
      "dirtyFields.denpyoshubetsuCd",
      fields.denpyoshubetsuCd ?? ""
    );
    methods.setValue("dirtyFields.tenpudenpyoCd", fields.tenpudenpyoCd ?? "");
    methods.setValue("dirtyFields.unsogaishaCd", fields.unsogaishaCd ?? "");
    methods.setValue("dirtyFields.uriYmd", fields.uriYmd ?? "");
  };
  const resetMeiDirtyFields = () => {
    const fields = meiMethods.getValues();
    meiMethods.setValue("dirtyFields.shohinCd", fields.shohinCd ?? "");
    meiMethods.setValue("dirtyFields.janCd", fields.janCd ?? "");
    meiMethods.setValue("dirtyFields.sokoCd", fields.sokoCd ?? "");
    meiMethods.setValue("dirtyFields.sotosunW", fields.sotosunW ?? "");
    meiMethods.setValue("dirtyFields.sotosunH", fields.sotosunH ?? "");
    meiMethods.setValue("dirtyFields.urisu", fields.urisu ?? "");
    meiMethods.setValue("dirtyFields.jodaitanka", fields.jodaitanka ?? "");
    meiMethods.setValue("dirtyFields.uritanka", fields.uritanka ?? "");
    meiMethods.setValue("dirtyFields.kakeritsu", fields.kakeritsu ?? "");
  };

  // SCodeの値
  const [kasanfugoPlusList, setKasanfugoPlusList] = useState<number[]>([]);

  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 遷移元データ取得用
  const navigate = useNavigate();
  const location = useLocation();
  const inputData = location.state as B020010InputData;
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 登録ボタンクリック時に出す確認ダイアログオープン用
  const [openCreateConfirm, setOpenCreateConfirm] = useState(false);
  // 更新ボタンクリック時に出す確認ダイアログオープン用
  const [openUpdateConfirm, setOpenUpdateConfirm] = useState(false);

  // 再レンダリング用フラグ
  // const [reRender, setReRender] = useState(false);
  const reRendering = () => {
    resetDirtyFields();
    resetMeiDirtyFields();
    // setReRender(!reRender);
  };

  // 活性設定
  // 参照モードかどうか
  const isReference = methods.watch("editKbn") === editKbn.reference;

  // 得意先.諸口が「1：諸口」かどうか
  const isNonyuShokuchi =
    methods.watch("nonyuShokuchiKbn") === shokuchiKbn.shokuchi;
  // 添付伝票の入力可否(伝票種別が未入力時、入力不可)
  const isTenpudenpyoCdDisabled = methods.watch("denpyoshubetsuCd") === "";
  // ベース上代単価、上代単価が一致するかどうか(手入力上代区分)
  const isTenyuryokujodaiKbn =
    Number(meiMethods.watch("basejodaitanka")) ===
    Number(meiMethods.watch("jodaitanka"));
  // ベース下代単価、下代単価が一致するかどうか(手入力売上区分)
  const isTenyuryokuuriKbn =
    Number(meiMethods.watch("baseuritanka")) ===
    Number(meiMethods.watch("uritanka"));
  // 明細入力部への入力可否(有効な得意先が入力済(諸口区分が取得済)、かつ消費税率が取得済)
  const isMeiDisabled =
    typeof methods.watch("tokuiShokuchiKbn") === "undefined" ||
    methods.watch("zeiRitsu") === "";
  // 商品.諸口区分が「1:諸口」かどうか
  const isShohinShokuchiKbn =
    meiMethods.watch("shokuchiKbn") === shohinShokuchiKbn.shokuchi;
  // 商品.商品種別区分が「4:受注生産品」かどうか
  const isMeiJuchuSeisanhin =
    meiMethods.watch("shohinshubetsuKbn") === shohinshubetsuKbn.madeToOrder;
  // 商品.セット商品区分が「1:セット品」かどうか
  const isSetshohinKbn = meiMethods.watch("setshohinKbn") === setshohinKbn.set;
  const isKoseiDisabled = isMeiDisabled || !isSetshohinKbn;
  // 明細入力部の金額の入力可否(売上数が入力済、かつ下代が入力済の場合、入力不可)
  const isKingakuDisabled =
    meiMethods.watch("urisu") !== "" && meiMethods.watch("uritanka") !== "";
  //
  const isUchiwakeNebiki =
    Number(meiMethods.watch("uchiwakeKbn")?.value) === uchiwakeKbnNebiki;

  // 初期表示(編集・参照時の設定)
  useEffect(() => {
    // unregisterを使用する値をresetで初期化(defalutValueが無視され、初期値にundifindが設定されることがあるため)
    methods.reset();
    methods.reset({
      ...methods.getValues(),
      tokuiCd: "",
      tokuishitenCd: "",
      nonyuCd: "",
      nonyushitenCd: "",
    });
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
      janCd: "",
    });

    if (inputData === null) {
      return;
    }
    // 編集区分の設定
    methods.setValue("editKbn", inputData.editKbn);

    // 入力プロパティの反映
    const uriage = inputData.uriage;
    if (typeof uriage === "undefined") return;
    // 売上データ設定
    methods.setValue(
      "uridenpyohakoKbn",
      getSCode(DenpyoHakoKbn, uriage.uridenpyohakoKbn)
    );
    methods.setValue("uridenpyoNo", uriage.uridenpyoNo ?? "");
    methods.setValue("senyodenpyoNo", uriage.senyodenpyoNo ?? "");
    methods.setValue("juchudenpyoNo", uriage.juchudenpyoNo ?? "");
    methods.setValue("uriageKbn", getSCode(ChohaKbn, uriage.uriageKbn));
    methods.setValue("tankaKakeritsu", uriage.tankaKakeritsu ?? "");
    methods.setValue("zeimarumeKbn", Number(uriage.zeimarumeKbn));
    methods.setValue("kinmarumeKbn", Number(uriage.kinmarumeKbn));
    methods.setValue("tokuiShokuchiKbn", Number(uriage.tokuiShokuchiKbn));
    methods.setValue("tokuiCd", uriage.tokuiCd ?? "");
    methods.setValue("tokuishitenCd", uriage.tokuishitenCd ?? "");
    methods.setValue("tokuiNm", uriage.tokuiNm ?? "");
    methods.setValue("tokuiPostCd", uriage.tokuipostCd ?? "");
    // methods.setValue("tokuiPostCd", uriage.tokuiPostCd ?? "");
    methods.setValue("tokuiAddress1", uriage.tokuiaddress1 ?? "");
    // methods.setValue("tokuiAddress1", uriage.tokuiAddress1 ?? "");
    methods.setValue("tokuiAddress2", uriage.tokuiaddress2 ?? "");
    // methods.setValue("tokuiAddress2", uriage.tokuiAddress2 ?? "");
    methods.setValue("tokuiTelNo", uriage.tokuitelNo ?? "");
    // methods.setValue("tokuiTelNo", uriage.tokuiTelNo ?? "");
    methods.setValue("tokuiFaxNo", uriage.tokuifaxNo ?? "");
    // methods.setValue("tokuiFaxNo", uriage.tokuiFaxNo ?? "");
    methods.setValue("denpyogyosu", Number(uriage.denpyogyosu));
    methods.setValue("shimeD", uriage.shimeD ?? "");
    methods.setValue("shainCd", uriage.shainCd ?? "");
    methods.setValue("shainNm", uriage.shainNm ?? "");
    methods.setValue("nonyuShokuchiKbn", Number(uriage.nonyuShokuchiKbn));
    methods.setValue("nonyuCd", uriage.nonyuCd ?? "");
    methods.setValue("nonyushitenCd", uriage.nonyushitenCd ?? "");
    methods.setValue("nonyuNm", uriage.nonyuNm ?? "");
    methods.setValue("nonyuPostCd", uriage.nonyupostCd ?? "");
    // methods.setValue("nonyuPostCd", uriage.nonyuPostCd ?? "");
    methods.setValue("nonyuAddress1", uriage.nonyuaddress1 ?? "");
    // methods.setValue("nonyuAddress1", uriage.nonyuAddress1 ?? "");
    methods.setValue("nonyuAddress2", uriage.nonyuaddress2 ?? "");
    // methods.setValue("nonyuAddress2", uriage.nonyuAddress2 ?? "");
    methods.setValue("nonyuTelNo", uriage.nonyutelNo ?? "");
    // methods.setValue("nonyuTelNo", uriage.nonyuTelNo ?? "");
    methods.setValue("nonyuFaxNo", uriage.nonyufaxNo ?? "");
    // methods.setValue("nonyuFaxNo", uriage.nonyuFaxNo ?? "");
    methods.setValue("eigyoCd", uriage.eigyoCd ?? "");
    methods.setValue("uriYmd", uriage.uriYmd ?? "");
    methods.setValue("shukaYmd", uriage.shukaYmd ?? "");
    methods.setValue("hasosakiCd", getSCode(HasosakiCd, uriage.hasosakiCd));
    methods.setValue("hasokbnCd", getSCode(HasokbnCd, uriage.hasokbnCd));
    methods.setValue(
      "seikyushokisaiKbn",
      getSCode(SeikyusyoHakoKbn, uriage.seikyushokisaiKbn ?? "0")
    );
    methods.setValue("zeiKbnView", getSCode(ZeiKbn, uriage.zeiKbn));
    methods.setValue("zeiKbn", uriage.zeiKbn ?? "");
    methods.setValue("assistantCd", uriage.assistantCd ?? "");
    methods.setValue("assistantNm", uriage.assistantNm ?? "");
    methods.setValue("denpyoshubetsuCd", uriage.denpyoshubetsuCd ?? "");
    methods.setValue("denpyoshubetsuNm", uriage.denpyoshubetsuNm ?? "");
    methods.setValue("tenpudenpyoCd", uriage.tenpudenpyoCd ?? "");
    methods.setValue("tenpudenpyoNm", uriage.tenpudenpyoNm ?? "");
    methods.setValue("bunrui", uriage.bunrui ?? "");
    methods.setValue("unsogaishaCd", uriage.unsogaishaCd ?? "");
    methods.setValue("unsogaishaNm", uriage.unsogaishaNm ?? "");
    methods.setValue("bumonCd", uriage.bumonCd ?? "");
    methods.setValue("bumonNm", uriage.bumonNm ?? "");
    methods.setValue("chumonNo", uriage.chumonNo ?? "");
    methods.setValue("denpyoKbn", uriage.denpyoKbn ?? "");
    methods.setValue("ritsu", uriage.ritsu ?? "");
    methods.setValue("hinbetsuNo", uriage.hinbetsuNo ?? "");
    methods.setValue("tantosha", uriage.tantosha ?? "");
    methods.setValue("bikoCd", uriage.bikoCd ?? "");
    methods.setValue("biko", uriage.biko ?? "");
    methods.setValue("bikoCdBefore", uriage.bikoCd ?? "");
    methods.setValue("nohinsaki", uriage.nohinsaki ?? "");
    methods.setValue("uribaNm", uriage.uribaNm ?? "");
    methods.setValue("naisen", uriage.naisen ?? "");
    methods.setValue("ediKbn", uriage.ediKbn ?? "");
    methods.setValue("ediMemo", uriage.ediMemo ?? "");
    methods.setValue("zeiRitsu", uriage.zeiRitsu ?? "");
    methods.setValue("jodaihyojiKbn", uriage.jodaihyojiKbn ?? "");

    if (uriage.uriageSakuseiKbn === null) {
      methods.setValue("uriageSakuseiKbn", undefined);
    } else {
      methods.setValue("uriageSakuseiKbn", Number(uriage.uriageSakuseiKbn));
    }

    methods.setValue("version", uriage.version ?? "");
    methods.setValue("tankamarumeKbn", uriage.tankamarumeKbn ?? "");
    methods.setValue("tankahasuichi", uriage.tankahasuichi ?? "");

    // 明細テーブル設定
    if (uriage.b020020GetMeiResponseList === null) return;

    // カラム「受注生産品」を設定するため、商品種別のチェック結果を配列に保持
    const juchuSeisanhinKbnList: string[] =
      uriage.b020020GetMeiResponseList.map((value) => {
        let isJuchuSeisanhinKbn: string = "";
        let isKoseiJuchuSeisanhinKbn: boolean = false;

        if (value.b020020GetMeiKoseiResponseList !== null) {
          // 構成品の中に受注生産品が含まれるかどうか
          isKoseiJuchuSeisanhinKbn = value.b020020GetMeiKoseiResponseList.some(
            (koseiData) =>
              Number(koseiData.shohinshubetsuKbn) ===
              shohinshubetsuKbn.madeToOrder
          );
        }

        // 受注生産品を含む場合
        if (
          Number(value.shohinshubetsuKbn) === shohinshubetsuKbn.madeToOrder ||
          isKoseiJuchuSeisanhinKbn
        ) {
          isJuchuSeisanhinKbn = juchuSeisanhinKbn.ari;
        }
        // 受注生産品を含まない場合
        else {
          isJuchuSeisanhinKbn = juchuSeisanhinKbn.nashi;
        }

        return isJuchuSeisanhinKbn;
      });

    const uriageMei = uriage.b020020GetMeiResponseList.map<Data>((value, i) => {
      // 移行データは行番号が連番ではない可能性があるため振り直しを行う
      const urigyoNo: number = i + 1;

      // ベース単価の算出
      let basejodaitanka: string;
      let baseuritanka: string;
      // セット商品の場合
      if (Number(value.setshohinKbn) === setshohinKbn.set) {
        // 上代単価
        basejodaitanka = value.setJodaitanka;
        // 下代単価
        baseuritanka = getJuchutanka(methods, basejodaitanka, value.kakeritsu);
      }
      // セット商品以外の場合
      else {
        // 単価区分「0:通常単価」の場合
        if (Number(value.tankaKbn) === tankaKbn.tujo) {
          // 取引先別単価マスタ.上代単価が取得できた場合
          if (value.toritankaJodaitanka !== null) {
            // 上代単価
            basejodaitanka = getJodaitanka(methods, value.toritankaJodaitanka);
            // 下代単価
            baseuritanka = getUchizeiJuchutanka(methods, value.toritankaTanka);
          }
          // 取得できなかった場合
          else {
            // 上代単価
            basejodaitanka = getJodaitanka(methods, value.tankaTanka);
            // 下代単価
            baseuritanka = getJuchutanka(
              methods,
              basejodaitanka,
              value.kakeritsu
            );
          }
        }
        // 単価区分「1:WH単価」の場合
        else {
          // 上代単価
          basejodaitanka = value.whJodaitanka;
          // 下代単価
          baseuritanka = getJuchutanka(
            methods,
            basejodaitanka,
            value.kakeritsu
          );
        }
      }

      // 前回分の受注数、材料引当数の設定
      let meiShohinCdBefore: string = "";
      let meiUrisuBefore: string = "";

      // 編集時の場合(複写時は設定しない)
      if (
        typeof uriage.uridenpyoNo !== "undefined" &&
        uriage.uridenpyoNo !== null
      ) {
        // 可能数が設定されている場合(受注生産品の場合、可能数は設定されない)
        if (typeof value.kanosu !== "undefined" && value.kanosu !== null) {
          meiShohinCdBefore = value.shohinCd;
          meiUrisuBefore = value.urisu;
        }
      }

      const mei: Data = {
        uridenpyoNo: value.uridenpyoNo ?? "",
        urigyoNo,
        juchudenpyoNo: value.juchudenpyoNo ?? "",
        juchugyoNo: value.juchugyoNo ?? "",
        uchiwakeKbn: value.uchiwakeKbn ?? "",
        kasanfugo: value.kasanfugo ?? undefined,
        uchiwakeKbnView: getSCode(UriageUchiwakeKbn, value.uchiwakeKbn)?.label,
        juchuSeisanhinKbnView: getSCode(
          JuchuSeisanhinKbn,
          juchuSeisanhinKbnList[i]
        )?.label,
        juchuSeisanhinKbn: juchuSeisanhinKbnList[i],
        shohinCd: value.shohinCd ?? "",
        shohinCdBefore: meiShohinCdBefore,
        janCd: value.janCd ?? "",
        aiteCd: value.aiteCd ?? "",
        shohinNm: value.shohinNm ?? "",
        vol: value.vol ?? "",
        sotosunW: value.sotosunW ?? "",
        sotosunH: value.sotosunH ?? "",
        uchisunW: value.uchisunW ?? "",
        uchisunH: value.uchisunH ?? "",
        urisu: value.urisu ?? "",
        urisuBefore: meiUrisuBefore,
        kanosu: value.kanosu ?? "",
        tenyuryokujodaiKbn: Number(value.tenyuryokujodaiKbn),
        tenyuryokuuriKbn: Number(value.tenyuryokuuriKbn),
        basejodaitanka,
        baseuritanka,
        jodaitanka: value.jodaitanka ?? "",
        uritanka: value.uritanka ?? "",
        kakeritsu: value.kakeritsu ?? "",
        uriKin: value.uriKin ?? "",
        sokoCd: value.sokoCd ?? "",
        sokoNm: value.sokoNm ?? "",
        sokoshubetsuKbn: Number(value.sokoshubetsuKbn) ?? undefined,
        meisaibikoCd: value.meisaibikoCd ?? "",
        meisaibiko: value.meisaibiko ?? "",
        kazeiKbn: Number(value.kazeiKbn) ?? undefined,
        setshohinKbn: Number(value.setshohinKbn) ?? undefined,
        tankaKbn: Number(value.tankaKbn) ?? undefined,
        shokuchiKbn: Number(value.shokuchiKbn) ?? undefined,
        shohinshubetsuKbn: Number(value.shohinshubetsuKbn) ?? undefined,
        whtankaCd: value.whtankaCd ?? "",
        zaikokanriKbn: Number(value.zaikokanriKbn) ?? undefined,
        crtDate: value.crtDate ?? "",
        crtshainCd: value.crtshainCd ?? "",
        koseiData: [],
      };
      // 構成データ設定
      if (value.b020020GetMeiKoseiResponseList === null) {
        return mei;
      }
      mei.koseiData = value.b020020GetMeiKoseiResponseList.map<KoseiData>(
        (value, i) => {
          // 移行データは行番号が連番ではない可能性があるため振り直しを行う
          const urikoseigyoNo: number = i + 1;

          // ベース単価の算出
          let setBasejodaitanka: string;
          let setBaseuritanka: string;

          // セット商品マスタ.上代単価が取得できた場合
          if (value.setJodaitanka !== null) {
            // 上代単価
            setBasejodaitanka = value.setJodaitanka;
            // 下代単価
            setBaseuritanka = getJuchutanka(
              methods,
              setBasejodaitanka,
              value.kakeritsu
            );
          }
          // セット商品マスタ.上代単価が取得できなかった場合
          else {
            // 単価区分「0:通常単価」の場合
            if (Number(value.tankaKbn) === tankaKbn.tujo) {
              // 取引先別単価マスタ.上代単価が取得できた場合
              if (value.toritankaJodaitanka !== null) {
                // 上代単価
                setBasejodaitanka = getJodaitanka(
                  methods,
                  value.toritankaJodaitanka
                );
                // 下代単価
                setBaseuritanka = getUchizeiJuchutanka(
                  methods,
                  value.toritankaTanka
                );
              }
              // 取得できなかった場合
              else {
                // 上代単価
                setBasejodaitanka = getJodaitanka(methods, value.tankaTanka);
                // 下代単価
                setBaseuritanka = getJuchutanka(
                  methods,
                  setBasejodaitanka,
                  value.kakeritsu
                );
              }
            }
            // 単価区分「1:WH単価」の場合
            else {
              // 上代単価
              setBasejodaitanka = value.whJodaitanka;
              // 下代単価
              setBaseuritanka = getJuchutanka(
                methods,
                setBasejodaitanka,
                value.kakeritsu
              );
            }
          }

          // 前回分の必要数の設定
          let meiKoseiShohinCdBefore: string = "";
          let meiKoseiHitsuyosuBefore: string = "";
          // 編集時の場合(複写時は設定しない)
          if (
            typeof uriage.uridenpyoNo !== "undefined" &&
            uriage.uridenpyoNo !== null
          ) {
            // 可能数が設定されている場合(受注生産品の場合、可能数は設定されない)
            if (typeof value.kanosu !== "undefined" && value.kanosu !== null) {
              meiKoseiShohinCdBefore = value.shohinCd;
              meiKoseiHitsuyosuBefore = value.hitsuyosu;
            }
          }

          const meiKosei: KoseiData = {
            uridenpyoNo: value.uridenpyoNo ?? "",
            urigyoNo,
            urikoseigyoNo,
            juchudenpyoNo: value.juchudenpyoNo ?? "",
            juchugyoNo: value.juchugyoNo ?? "",
            juchukoseigyoNo: value.juchukoseigyoNo ?? "",
            shohinCd: value.shohinCd ?? "",
            shohinCdBefore: meiKoseiShohinCdBefore,
            sokoCd: value.sokoCd ?? "",
            shohinNm: value.shohinNm ?? "",
            janCd: value.janCd ?? "",
            aiteCd: value.aiteCd ?? "",
            koseisu: value.koseisu ?? "",
            hitsuyosu: value.hitsuyosu ?? "",
            hitsuyosuBefore: meiKoseiHitsuyosuBefore,
            kanosu: value.kanosu ?? "",
            sokoNm: value.sokoNm,
            sokoshubetsuKbn: value.sokoshubetsuKbn ?? "",
            vol: value.vol ?? "",
            sotosunW: value.sotosunW ?? "",
            sotosunH: value.sotosunH ?? "",
            uchisunW: value.uchisunW ?? "",
            uchisunH: value.uchisunH ?? "",
            tenyuryokujodaiKbn: Number(value.tenyuryokujodaiKbn),
            tenyuryokuuriKbn: Number(value.tenyuryokuuriKbn),
            basejodaitanka: setBasejodaitanka,
            baseuritanka: setBaseuritanka,
            jodaitanka: value.jodaitanka ?? "",
            uritanka: value.uritanka ?? "",
            kakeritsu: value.kakeritsu ?? "",
            uriKin: value.uriKin ?? "",
            meisaikoseiBikoCd: value.meisaikoseiBikoCd ?? "",
            meisaikoseiBiko: value.meisaikoseiBiko ?? "",
            kazeiKbn: Number(value.kazeiKbn) ?? undefined,
            shohinshubetsuKbn: value.shohinshubetsuKbn ?? "",
            tankaKbn: value.tankaKbn ?? "",
            shokuchiKbn: value.shokuchiKbn ?? "",
            whtankaCd: value.whtankaCd ?? "",
            zaikokanriKbn: Number(value.zaikokanriKbn) ?? undefined,
            crtDate: value.crtDate ?? "",
            crtshainCd: value.crtshainCd ?? "",
          };
          return meiKosei;
        }
      );
      return mei;
    });
    // テーブルに反映
    setRows(uriageMei);
    reRendering();
  }, []);

  // 初期表示(共通)
  useEffect(() => {
    (async () => {
      // 消費税取得
      await B020010ZeiRitsu(methods);

      // 内訳区分リスト取得
      await B020010UchiwakeKbn(setKasanfugoPlusList, navigate, setMsg);

      // フォーカス
      switch (methods.watch("editKbn")) {
        case editKbn.register:
          focus(1);
          break;
        case editKbn.update:
          focus(2);
          break;
      }
    })();
  }, []);

  // 明細変更
  useEffect(() => {
    //合計金額算出
    handleGokeiCalculating();
    reRendering();
  }, [rows]);

  // 伝票日付変更時(カレンダー選択時にuriYmdを受け取る)
  const handleChangeUriYmd = (uriYmd: string = methods.getValues().uriYmd!) => {
    if (uriYmd === methods.getValues().dirtyFields?.uriYmd) return;
    // 未入力OR不正な値の場合、何もしない
    if (!uriYmd || uriYmd === "" || !validDate(uriYmd!)) return;

    // 必着日にコピー
    methods.setValue("shukaYmd", dateAt(uriYmd!));

    (async () => {
      // 消費税取得
      await B020010ZeiRitsu(methods);

      // 明細入力部の単価再設定
      await reacquisitionMeiTanka();

      // 明細が登録されている場合
      if (rows.length > 0) {
        // 明細再設定
        let shohinCdList: string[] = [];

        // 受注伝票番号が未設定の場合
        if (methods.getValues().juchudenpyoNo === "") {
          // 上代単価、下代単価が変更されていない商品コードを取得(重複排除)
          shohinCdList = Array.from(
            new Set(
              rows
                // 手入力区分をチェック
                .filter(
                  (row) => row.tenyuryokujodaiKbn === tenyuryokujodaiKbn.none
                )
                .filter((row) => row.tenyuryokuuriKbn === tenyuryokuuriKbn.none)
                // セット商品区分をチェック
                .filter((row) => row.setshohinKbn === setshohinKbn.single)
                // 単価区分をチェック
                .filter((row) => row.tankaKbn === tankaKbn.tujo)
                .map((row) => row.shohinCd!)
            )
          );
        }

        // 再設定する行が存在する場合
        if (shohinCdList.length > 0) {
          // 単価マスタより再取得を行う
          await B020010TankaList(
            methods,
            shohinCdList,
            rows,
            setRows,
            navigate,
            setMsg
          );
        }
        // 再設定する行が存在しない場合
        else {
          // 合計値(rowsに変更が無いため、明示的に処理を呼ぶ)
          handleGokeiCalculating();
        }
      }
      reRendering();
    })();
  };

  // 明細入力部の単価再設定
  const reacquisitionMeiTanka = async () => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();
    // 明細入力部が設定されていない場合(商品種別区分で判断)
    if (meiFields.shohinshubetsuKbn === undefined) return;

    // 手入力上代区分が「1:あり」の場合
    if (meiFields.tenyuryokujodaiKbn === tenyuryokujodaiKbn.exists) return;

    // 手入力売上区分が「1:あり」の場合
    if (meiFields.tenyuryokuuriKbn === tenyuryokuuriKbn.exists) return;

    // セット商品区分が「1:セット品」の場合
    if (meiFields.setshohinKbn === setshohinKbn.set) return;

    // 単価区分が「1:WH単価」の場合
    if (meiFields.tankaKbn === tankaKbn.wh) return;

    // 単価再取得処理を行う
    await B020010Tanka(methods, meiMethods, navigate, setMsg);
    reRendering();
  };

  // 内訳区分変更時
  const handleChangeUchiwakeKbn = () => {
    const { uchiwakeKbn, meiTab } = meiMethods.getValues();
    // 明細入力欄を全て初期化する。
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
      janCd: "",
    });

    // 選択された内訳区分が「2:値引」の場合
    if (Number(uchiwakeKbn?.value) === uchiwakeKbnNebiki) {
      // 売上数に「1」を設定(画面上は非表示)
      meiMethods.setValue("urisu", "1");
    }

    meiMethods.setValue(
      "uchiwakeKbn",
      getSCode(UriageUchiwakeKbn, uchiwakeKbn?.value!)
    );
    meiMethods.setValue("meiTab", meiTab);
    reRendering();
  };

  // 得意先変更(得意先コード、得意先支店コード)
  const handleChangeTokui = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    if (
      fields.tokuiCd === fields.dirtyFields?.tokuiCd &&
      fields.tokuishitenCd === fields.dirtyFields?.tokuishitenCd
    ) {
      return;
    }

    if (fields.tokuiCd === "" || fields.tokuishitenCd === "") {
      methods.setValue("tokuiShokuchiKbn", undefined);
      methods.setValue("tokuiNm", "");
      methods.setValue("tokuiPostCd", "");
      methods.setValue("tokuiAddress1", "");
      methods.setValue("tokuiAddress2", "");
      methods.setValue("tokuiTelNo", "");
      methods.setValue("tokuiFaxNo", "");
      methods.setValue("shainCd", "");
      methods.setValue("bumonCd", "");
      methods.setValue("shimeD", "");
      methods.setValue("zeiKbnView", getSCode(ZeiKbn, ""));
      methods.setValue("zeiKbn", "");
      methods.setValue("zeimarumeKbn", undefined);
      methods.setValue("jodaihyojiKbn", "");
      methods.setValue("kinmarumeKbn", undefined);
      methods.setValue("tankamarumeKbn", "");
      methods.setValue("tankahasuichi", "");
      methods.setValue("tankaKakeritsu", "");
      reRendering();
      return;
    }

    // 得意先関連項目設定
    (async () => {
      await B020010Tokui(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 納入先変更(得意先コード、得意先支店コード)
  const handleChangeNonyu = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    if (
      fields.nonyuCd === fields.dirtyFields?.nonyuCd &&
      fields.nonyushitenCd === fields.dirtyFields?.nonyushitenCd
    ) {
      return;
    }

    if (fields.nonyuCd === "" || fields.nonyushitenCd === "") {
      methods.setValue("nonyuShokuchiKbn", undefined);
      methods.setValue("nonyuNm", "");
      methods.setValue("nonyuPostCd", "");
      methods.setValue("nonyuAddress1", "");
      methods.setValue("nonyuAddress2", "");
      methods.setValue("nonyuTelNo", "");
      methods.setValue("nonyuFaxNo", "");
      reRendering();
      return;
    }

    // 納入先関連項目設定
    (async () => {
      await B010010Nonyu(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 下代、売上金額設定
  const handleCalcUritankaUriKin = () => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();

    if (
      meiFields.kakeritsu === meiFields.dirtyFields?.kakeritsu &&
      meiFields.jodaitanka === meiFields.dirtyFields?.jodaitanka
    ) {
      return;
    }

    // 上代単価、掛率が未入力の場合、何もしない
    if (meiFields.jodaitanka === "") return;
    if (meiFields.kakeritsu === "") return;

    // 手入力受注区分が「1:有り」の場合、何もしない
    if (!isTenyuryokuuriKbn) return;

    // 下代単価取得
    const uritanka: string = getJuchutanka(
      methods,
      meiFields.jodaitanka!,
      meiFields.kakeritsu!
    );
    // 下代単価
    meiMethods.setValue("uritanka", uritanka);
    // ベース下代単価
    meiMethods.setValue("baseuritanka", uritanka);

    // 売上金額
    handleCalcUriKin();
    reRendering();
  };

  // 下代入力時設定
  const handleCalcJuchuKinFromUritanka = () => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();
    if (meiFields.uritanka === meiFields.dirtyFields?.uritanka) {
      return;
    }
    handleCalcUriKin();
    reRendering();
  };

  // 売上金額設定
  const handleCalcUriKin = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();
    // 売上金額
    meiMethods.setValue(
      "uriKin",
      getJuchuKin(meiFields.uritanka!, meiFields.urisu!, fields.kinmarumeKbn!)
    );
  };

  // 売上数変更
  const handleChangeUrisu = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();

    // セット構成品が存在する場合
    if (meiFields.koseiData && Object.keys(meiFields.koseiData).length !== 0) {
      // 構成品データの更新
      const newRows = meiFields.koseiData?.map((koseiRow: KoseiData) => {
        // 必要数
        koseiRow.hitsuyosu = getHitsuyosu(koseiRow.koseisu!, meiFields.urisu!);

        // 構成品.売上金額
        koseiRow.uriKin = getJuchuKin(
          koseiRow.uritanka!,
          koseiRow.hitsuyosu!,
          fields.kinmarumeKbn!
        );
        reRendering();
        return koseiRow;
      });
      meiMethods.setValue("koseiData", newRows);
      reRendering();
    }

    // 売上金額
    meiMethods.setValue(
      "uriKin",
      getJuchuKin(meiFields.uritanka!, meiFields.urisu!, fields.kinmarumeKbn!)
    );
    reRendering();
  };

  // 売上担当者変更
  const handleChangeShain = () => {
    const fields = methods.getValues();
    if (fields.shainCd === fields.dirtyFields?.shainCd) {
      return;
    }
    (async () => {
      await B000140Shain(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 伝票種別変更
  const handleChangeDenpyoshubetsu = () => {
    const fields = methods.getValues();
    if (fields.denpyoshubetsuCd === fields.dirtyFields?.denpyoshubetsuCd) {
      return;
    }

    (async () => {
      await B000111DenpyoshubetsuNmAndTenpudenpyo(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 添付伝票変更
  const handleChangeTenpudenpyo = () => {
    const fields = methods.getValues();
    if (fields.tenpudenpyoCd === fields.dirtyFields?.tenpudenpyoCd) {
      return;
    }

    (async () => {
      await B000111TenpudenpyoNmByDenpyoshubetsu(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 運送会社変更
  const handleChangeUnsogaisha = () => {
    const fields = methods.getValues();
    if (fields.unsogaishaCd === fields.dirtyFields?.unsogaishaCd) {
      return;
    }

    (async () => {
      await B000111UnsogaishaNm(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // アシスタント変更
  const handleChangeAssistant = () => {
    const fields = methods.getValues();
    if (fields.assistantCd === fields.dirtyFields?.assistantCd) {
      return;
    }

    (async () => {
      await B000140AssistantNm(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 備考変更
  const handleChangeBiko = () => {
    (async () => {
      await B000111Biko(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 商品コード変更
  const handleChangeShohinCd = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (meiFields.shohinCd === meiFields.dirtyFields?.shohinCd) return;
      await B020010HandleChangeShohinCd(methods, meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // Janコード変更
  const handleChangeJanCd = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (meiFields.janCd === meiFields.dirtyFields?.janCd) return;
      await B020010HandleChangeJanCd(methods, meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // 倉庫コード変更
  const handleChangeSokoCd = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (meiFields.sokoCd === meiFields.dirtyFields?.sokoCd) return;
      // 倉庫名表示
      await B000190SokoNmSokoshubetsuKbn(meiMethods, navigate, setMsg);
      // 引当可能数取得処理
      await B020010Kanosu(methods, meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // WH単価変更
  const handleChangeWhTanka = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (
        meiFields.sotosunW === meiFields.dirtyFields?.sotosunW &&
        meiFields.sotosunH === meiFields.dirtyFields?.sotosunH
      ) {
        return;
      }
      await B020010WhTanka(methods, meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // タブ切替
  const handleChangeMeiTab = () => {
    if (!meiMethods.watch("meiTab")) return;
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
      janCd: "",
    });
    meiMethods.setValue("meiTab", true);
  };

  // ダイアログ表示用（登録）
  const handleOpenCreateConfirm = () => {
    if (meiMethods.formState.isDirty) {
      setOpenCreateConfirm(true);
    } else {
      handleClickCreateButton();
    }
  };

  // ダイアログ表示用（更新）
  const handleOpenUpdateConfirm = () => {
    if (meiMethods.formState.isDirty) {
      setOpenUpdateConfirm(true);
    } else {
      handleClickUpdateButton();
    }
  };

  // キャンセル押下時（登録）
  const handleCancelCreateConfirm = () => {
    setOpenCreateConfirm(false);
  };
  // キャンセル押下時（更新）
  const handleCancelUpdateConfirm = () => {
    setOpenUpdateConfirm(false);
  };

  // 登録
  const handleClickCreateButton = () => {
    setOpenCreateConfirm(false);
    B020010Create(methods, rows)
      .then((response) => {
        methods.reset();
        methods.reset({
          ...methods.getValues(),
          tokuiCd: "",
          tokuishitenCd: "",
          nonyuCd: "",
          nonyushitenCd: "",
        });
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
          janCd: "",
        });
        setRows([]);

        (async () => {
          // 消費税取得
          await B020010ZeiRitsu(methods);
          setMsg(getClientMessage("B020010_001", response.data.uridenpyoNo));
          reRendering();
        })();
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 更新
  const handleClickUpdateButton = () => {
    setOpenUpdateConfirm(false);
    B020010Update(methods, rows)
      .then(() => {
        methods.reset();
        methods.reset({
          ...methods.getValues(),
          tokuiCd: "",
          tokuishitenCd: "",
          nonyuCd: "",
          nonyushitenCd: "",
        });
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
          janCd: "",
        });
        setRows([]);

        (async () => {
          // 消費税取得
          await B020010ZeiRitsu(methods);
          setMsg("売上データを更新しました。");
          reRendering();
        })();
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 明細登録
  const handleClickCreateMeiButton = () => {
    // 独自チェック
    if (invalidated()) {
      return;
    }

    // フィールドチェック
    meiMethods.handleSubmit(() => {
      // 明細に設定するデータを取得
      const urigyoNo: number = rows.length + 1;
      const data: Data = handleDataMapping(urigyoNo);
      // 明細を設定
      setRows([...rows, data]);
      setRowCount(urigyoNo);

      // 行選択の解除
      setRowData(undefined);

      // 明細クリア
      meiMethods.reset();
      meiMethods.reset({
        ...meiMethods.getValues(),
        shohinCd: "",
        janCd: "",
      });
      focus(31);
      reRendering();
    })();
  };

  // 明細更新
  const handleClickUpdateMeiButton = () => {
    // 独自チェック
    if (invalidated()) {
      return;
    }

    // フィールドチェック
    meiMethods.handleSubmit(
      () => {
        const urigyoNo: number = rowData?.urigyoNo!;
        // 明細に設定するデータを取得
        const data: Data = handleDataMapping(urigyoNo);
        // 明細を設定
        rows[urigyoNo - 1] = data;
        setRows([...rows]);

        // 行選択の解除
        setRowData(undefined);

        // 明細クリア
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
          janCd: "",
        });

        // 明細入力部を新規登録に変更する
        meiMethods.setValue("meiTab", true);
        reRendering();
      },
      (errors, event) => {
        console.log(errors);
      }
    )();
  };

  // 独自チェック
  const invalidated = (): boolean => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();
    // 行番号
    const urigyoNo: number = rowData?.urigyoNo ?? rows.length + 1;

    // 内訳区分の選択値が「通常」かどうか
    const isTujo: boolean = uchiwakeKbnTujo.some(
      (uchiwakeKbn) => uchiwakeKbn === meiFields.uchiwakeKbn?.value
    );
    // 内訳区分の選択値が「返品」かどうか
    const isHenpin: boolean = uchiwakeKbnHenpin.some(
      (uchiwakeKbn) => uchiwakeKbn === meiFields.uchiwakeKbn?.value
    );

    // 明細の内訳区分の登録値が「通常」かどうか
    let isRowsTujo: boolean = false;
    // 明細の内訳区分の登録値が「返品」かどうか
    let isRowsHenpin: boolean = false;
    for (const row of rows) {
      // 現在の編集行と一致する場合、チェックしない
      if (row.urigyoNo === urigyoNo) continue;

      // 内訳区分の登録値が「通常」かどうか
      isRowsTujo = uchiwakeKbnTujo.some(
        (uchiwakeKbn) => uchiwakeKbn === row.uchiwakeKbn?.toString()
      );
      if (isRowsTujo) break;

      // 内訳区分の登録値が「返品」かどうか
      isRowsHenpin = uchiwakeKbnHenpin.some(
        (uchiwakeKbn) => uchiwakeKbn === row.uchiwakeKbn?.toString()
      );
      if (isRowsHenpin) break;
    }

    // ☆明細登録可能数チェック
    // 明細行追加で伝票行数を超える場合
    if (urigyoNo > fields.denpyogyosu!) {
      setMsg(getClientError("B020010_001"));
      return true;
    }

    // ☆入力値チェック

    // 売上数に0以外の値が入力されているか
    if (Number(meiFields.urisu) === 0) {
      setMsg(getClientError("B020010_022"));
      return true;
    }

    // 商品種別区分が「9:材料品」の場合
    if (meiFields.shohinshubetsuKbn! === shohinshubetsuKbn.materials) {
      setMsg(getClientError("B020010_021"));
      return true;
    }

    // 外寸の入力値チェック
    if (meiFields.sotosunH || meiFields.sotosunW) {
      // 外寸が片方だけ入力されている場合エラー
      if (!meiFields.sotosunW) {
        setMsg(getClientError("B020010_002"));
        return true;
      }
      if (!meiFields.sotosunH) {
        setMsg(getClientError("B020010_003"));
        return true;
      }
    }
    // 内寸の入力値チェック
    if (meiFields.uchisunH || meiFields.uchisunW) {
      // 内寸が片方だけ入力されている場合エラー
      if (!meiFields.uchisunW) {
        setMsg(getClientError("B020010_006"));
        return true;
      }
      if (!meiFields.uchisunH) {
        setMsg(getClientError("B020010_007"));
        return true;
      }
    }

    // 明細が登録されている場合、内訳区分が混在していないかチェック
    if (urigyoNo > 1) {
      // 売上明細の内訳区分に通常(0 ～ 5)と返品(10 ～ 15)が混在している場合
      if (isTujo !== isRowsTujo) {
        setMsg(getClientError("B020010_010"));
        return true;
      }

      if (isHenpin !== isRowsHenpin) {
        setMsg(getClientError("B020010_010"));
        return true;
      }
    }

    // 売上伝票番号が undefined ではない場合(売上入力の更新時)、かつ行を選択中の場合
    if (typeof fields.uridenpyoNo !== "undefined" && urigyoNo <= rows.length) {
      // 編集中の行の内訳区分の選択値が「通常」かどうか
      const isSelectedRowTujo: boolean = uchiwakeKbnTujo.some(
        (uchiwakeKbn) =>
          uchiwakeKbn === rows[urigyoNo - 1].uchiwakeKbn?.toString()
      );
      // 編集中の行の内訳区分の選択値が「返品」かどうか
      const isSelectedRowHenpin: boolean = uchiwakeKbnHenpin.some(
        (uchiwakeKbn) =>
          uchiwakeKbn === rows[urigyoNo - 1].uchiwakeKbn?.toString()
      );

      // 内訳区分が通常(0 ～ 5)⇔ 返品(10 ～ 15)で変更されている場合エラー
      if (isTujo !== isSelectedRowTujo) {
        setMsg(getClientError("B020010_011"));
        return true;
      }
      if (isHenpin !== isSelectedRowHenpin) {
        setMsg(getClientError("B020010_011"));
        return true;
      }
    }

    // 商品種別区分が「4」(受注生産)ではない場合
    if (meiFields.shohinshubetsuKbn !== shohinshubetsuKbn.madeToOrder) {
      // 倉庫コード未入力の場合
      if (meiFields.sokoCd === "") {
        setMsg(getClientError("B020010_012"));
        return true;
      }
    }

    // 上代合計・下代合計の金額が9桁より大きい場合エラー
    // 上代合計(現在編集中の行を除いた合計値を取得)
    const jodaitankaGokei: string = rows
      .filter(function (source: Data) {
        return Number(source.urigyoNo) !== urigyoNo;
      })
      .reduce((acc: Big, row: Data): Big => {
        return acc.plus(new Big(row.jodaitanka ? row.jodaitanka : "0"));
      }, new Big("0"))
      .plus(new Big(meiFields.jodaitanka ? meiFields.jodaitanka : "0"))
      .toString();
    // 売上金額が9桁より大きい場合
    if (jodaitankaGokei.length > jodaitankaMaxLength) {
      setMsg(getClientError("B020010_013"));
      return true;
    }

    // 下代合計(現在編集中の行を除いた合計値を取得)
    const uritankaGokei: string = rows
      .filter(function (source: Data) {
        return Number(source.urigyoNo) !== urigyoNo;
      })
      .reduce((acc: Big, row: Data): Big => {
        return acc.plus(new Big(row.uritanka ? row.uritanka : "0"));
      }, new Big("0"))
      .plus(new Big(meiFields.uritanka ? meiFields.uritanka : "0"))
      .toString();
    // 売上金額が9桁より大きい場合
    if (uritankaGokei.length > uritankaMaxLength) {
      setMsg(getClientError("B020010_014"));
      return true;
    }

    // ☆売上数チェック
    // 売上作成区分 が 受注確定(0)
    if (fields.uriageSakuseiKbn === uriagesakuseiKbn.juchuKakutei) {
      // 売上数がマイナスの場合エラー
      if (Number(meiFields.urisu) < urisuThreshold) {
        setMsg(getClientError("B020010_015"));
        return true;
      }
    }

    //内訳区分が返品(10~15)
    if (isHenpin) {
      // 売上数がマイナスの場合エラー
      if (Number(meiFields.urisu) < urisuThreshold) {
        setMsg(getClientError("B020010_015"));
        return true;
      }
    }

    // ☆倉庫種別チェック
    // 売上作成区分、内訳区分、商品種別区分をチェックする。

    // 売上作成区分が「1:新規作成」の場合
    else if (fields.uriageSakuseiKbn === uriagesakuseiKbn.new) {
      // 内訳区分が通常(0~5)
      if (isTujo) {
        // 倉庫種別が「4」(返品倉庫)、倉庫種別が「5」(その他倉庫)ではない場合エラー
        if (
          meiFields.sokoshubetsuKbn !== sokoshubetsuKbn.henpinSoko &&
          meiFields.sokoshubetsuKbn !== sokoshubetsuKbn.othersSoko
        ) {
          setMsg(getClientError("B020010_017"));
          return true;
        }
      }

      // 内訳区分が返品(10~15)
      // 倉庫種別が「4」(返品倉庫)ではない場合エラー
      if (
        isHenpin &&
        meiFields.sokoshubetsuKbn !== sokoshubetsuKbn.henpinSoko
      ) {
        setMsg(getClientError("B020010_018"));
        return true;
      }
    }

    // ☆可能数チェック

    // 売上作成区分.受注確定の場合は可能数チェックしない
    if (fields.uriageSakuseiKbn !== uriagesakuseiKbn.juchuKakutei) {
      // 内訳区分と商品種別区分をチェックする。
      // 在庫管理区分が1「する」の場合
      if (meiFields.zaikokanriKbn?.toString() === zaikokanriKbn.on) {
        // 内訳区分が通常(0~5)
        if (isTujo) {
          // 商品コードが前回分の明細.商品コードと同じ場合
          if (meiFields.shohinCd === meiFields.shohinCdBefore) {
            // 前回分の売上数を考慮した可能数チェックを行う
            // セット品の場合
            if (meiFields.setshohinKbn === setshohinKbn.set) {
              // セット構成品が設定されている場合
              if (Object.keys(meiFields.koseiData!).length !== 0) {
                let isKoseiKanosuFusoku: boolean = false;

                for (const kosei of meiFields.koseiData!) {
                  // 在庫管理区分が0「しない」の場合
                  if (kosei.zaikokanriKbn?.toString() === zaikokanriKbn.off) {
                    // チェックしない
                    continue;
                  }

                  // 必要数がプラスで、必要数が可能数以下でない場合エラー
                  if (
                    Number(kosei.hitsuyosu) >= urisuThreshold &&
                    !(
                      Number(kosei.hitsuyosu) <=
                      Number(kosei.kanosu) + Number(kosei.hitsuyosuBefore)
                    )
                  ) {
                    isKoseiKanosuFusoku = true;
                    break;
                  }
                }

                // 引当可能かチェック
                if (isKoseiKanosuFusoku) {
                  setMsg(getClientError("B020010_019"));
                  return true;
                }
              }
            }
            // セット品以外の場合
            else {
              // 可能数が空の場合は引当可能かチェックしない(受注生産品のため)
              if (meiFields.kanosu !== null && meiFields.kanosu !== "") {
                // 売上数がプラスで、売上数が可能数以下でない場合エラー
                if (
                  Number(meiFields.urisu) >= urisuThreshold &&
                  !(
                    Number(meiFields.urisu) <=
                    Number(meiFields.kanosu) + Number(meiFields.urisuBefore)
                  )
                ) {
                  setMsg(getClientError("B020010_019"));
                  return true;
                }
              }
            }
          }
          // 商品コードが前回分の明細.商品コードと同じではない場合
          else {
            // 可能数が空の場合は引当可能かチェックしない(受注生産品のため)
            if (meiFields.kanosu !== null && meiFields.kanosu !== "") {
              // 売上数がプラスで、売上数が可能数以下でない場合エラー
              if (
                Number(meiFields.urisu) >= urisuThreshold &&
                !(Number(meiFields.urisu) <= Number(meiFields.kanosu))
              ) {
                setMsg(getClientError("B020010_019"));
                return true;
              }
            }
          }

          // 売上数がマイナスで、倉庫が返品倉庫でない場合エラー
          if (
            Number(meiFields.urisu) < urisuThreshold &&
            meiFields.sokoshubetsuKbn !== sokoshubetsuKbn.henpinSoko
          ) {
            setMsg(getClientError("B020010_018"));
            return true;
          }
        }

        // 内訳区分が返品(10~15)
        if (isHenpin) {
          // 売上数がプラスでない場合エラー表示し、処理を中止する。
          // マイナスの場合エラー
          if (Number(meiFields.urisu) < urisuThreshold) {
            setMsg(getClientError("B020010_015"));
            return true;
          }
        }
      }
    }

    // WH単価の商品の場合
    if (meiFields.tankaKbn === tankaKbn.wh) {
      // 外寸が入っていない場合
      if (!meiFields.sotosunW) {
        setMsg(getClientError("B020010_020"));
        return true;
      }
      if (!meiFields.sotosunH) {
        setMsg(getClientError("B020010_020"));
        return true;
      }
      // 外寸が0以下の場合
      if (Number(meiFields.sotosunW) < whMin) {
        setMsg(getClientError("B020010_004"));
        return true;
      }
      if (Number(meiFields.sotosunH) < whMin) {
        setMsg(getClientError("B020010_005"));
        return true;
      }
    }

    return false;
  };

  // 明細のデータマッピング
  const handleDataMapping = (urigyoNo: number): Data => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();

    // 加算符号の設定
    // 内訳区分の選択値が「1:プラス」かどうか
    const isKasanfugoPlus: boolean = kasanfugoPlusList.some(
      (kasanfugoPlus) => kasanfugoPlus === Number(meiFields.uchiwakeKbn?.value)
    );
    let kasanfugo: number;
    // 加算符号がプラスの場合
    if (isKasanfugoPlus) {
      kasanfugo = kasanfugoPlus;
    } else {
      // 加算符号がマイナスの場合
      kasanfugo = kasanfugoMinus;
    }

    const data: Data = {
      urigyoNo,
      uridenpyoNo: meiFields.uridenpyoNo,
      juchudenpyoNo: meiFields.juchudenpyoNo,
      juchugyoNo: meiFields.juchugyoNo,
      uchiwakeKbnView: meiFields.uchiwakeKbn?.label,
      uchiwakeKbn: meiFields.uchiwakeKbn?.value,
      kasanfugo,
      juchuSeisanhinKbnView: meiFields.juchuSeisanhinKbn?.label,
      juchuSeisanhinKbn: meiFields.juchuSeisanhinKbn?.value,
      shohinCd: meiFields.shohinCd,
      shohinCdBefore: meiFields.shohinCdBefore,
      janCd: meiFields.janCd,
      shohinNm: meiFields.shohinNm,
      sokoCd: meiFields.sokoCd,
      sokoNm: meiFields.sokoNm,
      sokoshubetsuKbn: meiFields.sokoshubetsuKbn,
      aiteCd: meiFields.aiteCd,
      sotosunW: meiFields.sotosunW,
      sotosunH: meiFields.sotosunH,
      uchisunW: meiFields.uchisunW,
      uchisunH: meiFields.uchisunH,
      vol: meiFields.vol,
      urisu: meiFields.urisu,
      urisuBefore: meiFields.urisuBefore,
      kanosu: meiFields.kanosu,
      // 手入力上代区分の設定(一致する場合「0：変更なし」、一致する場合「1：変更あり」)
      tenyuryokujodaiKbn: isTenyuryokujodaiKbn
        ? tenyuryokujodaiKbn.none
        : tenyuryokujodaiKbn.exists,
      // 手入力売上区分の設定(一致する場合「0：変更なし」、一致する場合「1：変更あり」)
      tenyuryokuuriKbn: isTenyuryokuuriKbn
        ? tenyuryokuuriKbn.none
        : tenyuryokuuriKbn.exists,
      basejodaitanka: meiFields.basejodaitanka,
      baseuritanka: meiFields.baseuritanka,
      jodaitanka: meiFields.jodaitanka,
      uritanka: meiFields.uritanka,
      kakeritsu: meiFields.kakeritsu,
      uriKin: meiFields.uriKin,
      meisaibikoCd: meiFields.meisaibikoCd,
      meisaibiko: meiFields.meisaibiko,
      kazeiKbn: meiFields.kazeiKbn,
      setshohinKbn: meiFields.setshohinKbn,
      shohinshubetsuKbn: meiFields.shohinshubetsuKbn,
      tankaKbn: meiFields.tankaKbn,
      shokuchiKbn: meiFields.shokuchiKbn,
      whtankaCd: meiFields.whtankaCd,
      zaikokanriKbn: meiFields.zaikokanriKbn,
      crtDate: meiFields.crtDate,
      crtshainCd: meiFields.crtshainCd,
      koseiData: meiFields.koseiData?.map(
        // 構成データに売上行番号を設定
        (source: KoseiData) => {
          source.urigyoNo = urigyoNo;
          return source;
        }
      ),
    };

    return data;
  };

  // 明細削除
  const handleClickDeleteMeiButton = () => {
    // 選択行の取得
    if (typeof rowData?.urigyoNo === "undefined") return;
    const urigyoNo: number = rowData.urigyoNo;
    // 対象の行を削除
    const newRows = rows
      .filter(function (source: Data) {
        return source.urigyoNo !== urigyoNo;
      })
      // 連番の振り直し
      .map((meiRow: any, index) => {
        // 明細
        meiRow.urigyoNo = ++index;
        // セット商品以外の場合
        if (meiRow.setshohinKbn === 0) {
          // 何もしない
          return meiRow;
        }
        // セット構成品の売上行番号を再設定
        meiRow.koseiData.map((koseiRow: KoseiData) => {
          koseiRow.urigyoNo = index;
          return koseiRow;
        });
        return meiRow;
      });

    setRows(newRows);

    // 行選択の解除
    setRowData(undefined);

    // 明細クリア
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
      janCd: "",
    });

    // 明細入力部を新規登録に変更する
    meiMethods.setValue("meiTab", true);
    reRendering();
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (data: Data) => {
    // データを保存
    setRowData(data);
    if (typeof data.urigyoNo !== "undefined") {
      // 明細入力部を編集に変更する
      meiMethods.setValue("meiTab", false);
      // 明細入力部に値を設定する
      meiMethods.setValue("juchugyoNo", data.juchugyoNo);
      meiMethods.setValue(
        "uchiwakeKbn",
        getSCode(UriageUchiwakeKbn, data.uchiwakeKbn ?? "0")
      );
      meiMethods.setValue("kasanfugo", data.kasanfugo);
      meiMethods.setValue(
        "juchuSeisanhinKbn",
        getSCode(
          JuchuSeisanhinKbn,
          data.juchuSeisanhinKbn ?? juchuSeisanhinKbn.nashi
        )
      );
      meiMethods.setValue("shohinCd", data.shohinCd);
      meiMethods.setValue("shohinCdBefore", data.shohinCdBefore);
      meiMethods.setValue("janCd", data.janCd);
      meiMethods.setValue("shohinNm", data.shohinNm);
      meiMethods.setValue("aiteCd", data.aiteCd);
      meiMethods.setValue("sokoCd", data.sokoCd);
      meiMethods.setValue("sokoNm", data.sokoNm);
      meiMethods.setValue("vol", data.vol);
      meiMethods.setValue("sotosunW", data.sotosunW);
      meiMethods.setValue("sotosunH", data.sotosunH);
      meiMethods.setValue("uchisunW", data.uchisunW);
      meiMethods.setValue("uchisunH", data.uchisunH);
      meiMethods.setValue("urisu", data.urisu);
      meiMethods.setValue("urisuBefore", data.urisuBefore);
      meiMethods.setValue("kanosu", data.kanosu);
      meiMethods.setValue("tenyuryokujodaiKbn", data.tenyuryokujodaiKbn);
      meiMethods.setValue("tenyuryokuuriKbn", data.tenyuryokuuriKbn);
      meiMethods.setValue("basejodaitanka", data.basejodaitanka);
      meiMethods.setValue("baseuritanka", data.baseuritanka);
      meiMethods.setValue("jodaitanka", data.jodaitanka);
      meiMethods.setValue("uritanka", data.uritanka);
      meiMethods.setValue("kakeritsu", data.kakeritsu);
      meiMethods.setValue("uriKin", data.uriKin);
      meiMethods.setValue("meisaibikoCd", data.meisaibikoCd);
      meiMethods.setValue("meisaibikoCdBefore", data.meisaibikoCd);
      meiMethods.setValue("meisaibiko", data.meisaibiko);
      meiMethods.setValue(
        "kazeiKbnView",
        getSCode(HyoziKazeiKbn, data.kazeiKbn ?? "")?.label
      );
      meiMethods.setValue("kazeiKbn", data.kazeiKbn);
      meiMethods.setValue("setshohinKbn", data.setshohinKbn);
      meiMethods.setValue("crtDate", data.crtDate);
      meiMethods.setValue("crtshainCd", data.crtshainCd);
      meiMethods.setValue("shohinshubetsuKbn", data.shohinshubetsuKbn);
      meiMethods.setValue("tankaKbn", data.tankaKbn);
      meiMethods.setValue("shokuchiKbn", data.shokuchiKbn);
      meiMethods.setValue("whtankaCd", data.whtankaCd);
      meiMethods.setValue("sokoshubetsuKbn", data.sokoshubetsuKbn);
      meiMethods.setValue("zaikokanriKbn", data.zaikokanriKbn);
      meiMethods.setValue("koseiData", data.koseiData);
      focus(31);
      reRendering();
    }
  };

  //合計金額算出
  const handleGokeiCalculating = () => {
    // 明細が設定されていない場合
    if (rows.length === 0) {
      // 合計金額の初期化のみ行う
      methods.setValue("uriKinGokei", "");
      methods.setValue("zeiGokei", "");
      methods.setValue("denpyoGokei", "");
      return;
    }

    // フォームのデータを取得する。
    const fields = methods.getValues();

    // 売上金額合計
    const uriKinGokei: Big = rows.reduce((acc: Big, row: Data): Big => {
      // return acc.plus(new Big(row.uriKin ? row.uriKin : "0"));
      return acc.plus(
        new Big(row.uriKin ? row.uriKin : "0").times(
          new Big(row.kasanfugo ? row.kasanfugo : kasanfugoPlus)
        )
      );
    }, new Big("0"));

    // 消費税
    let zeiGokei: Big = new Big(0);
    // 消費税区分が「0」(外税/明細単位)の場合
    if (fields.zeiKbn === zeiKbn.sotozeiMei) {
      // 税丸め区分を取得
      let zeiRoundingMode: RoundingMode;
      // 四捨五入
      if (fields.zeimarumeKbn === zeimarumeKbn.shishagonyu) {
        zeiRoundingMode = Big.roundHalfUp;
      }
      //切り捨て
      else if (fields.zeimarumeKbn === zeimarumeKbn.kirisute) {
        zeiRoundingMode = Big.roundDown;
      }
      //切り上げ
      else if (fields.zeimarumeKbn === zeimarumeKbn.kiriage) {
        zeiRoundingMode = Big.roundUp;
      }

      // 消費税合計 ※小数点以下は得意先毎の丸め処理を行う
      zeiGokei = uriKinGokei
        .times(new Big(fields.zeiRitsu ?? "0"))
        .div(new Big("100"))
        .round(0, zeiRoundingMode!);
    }
    // 消費税区分が「1」(外税/伝票単位)の場合
    if (fields.zeiKbn === zeiKbn.sotozeiDen) {
      // 税丸め区分を取得
      let zeiRoundingMode: RoundingMode;
      // 四捨五入
      if (fields.zeimarumeKbn === zeimarumeKbn.shishagonyu) {
        zeiRoundingMode = Big.roundHalfUp;
      }
      //切り捨て
      else if (fields.zeimarumeKbn === zeimarumeKbn.kirisute) {
        zeiRoundingMode = Big.roundDown;
      }
      //切り上げ
      else if (fields.zeimarumeKbn === zeimarumeKbn.kiriage) {
        zeiRoundingMode = Big.roundUp;
      }

      // 消費税合計 ※小数点以下は得意先毎の丸め処理を行う
      zeiGokei = uriKinGokei
        .times(new Big(fields.zeiRitsu ?? "0"))
        .div(new Big("100"))
        .round(0, zeiRoundingMode!);
    }

    // 伝票合計
    const denpyoGokei: Big = uriKinGokei.plus(zeiGokei);

    methods.setValue("uriKinGokei", uriKinGokei.toString());
    methods.setValue("zeiGokei", zeiGokei.toString());
    methods.setValue("denpyoGokei", denpyoGokei.toString());
  };

  // 補足の引数を設定
  const getSupplementProps = () => {
    return {
      editKbn: methods.watch("editKbn"),
      uridenpyoNo: methods.watch("uridenpyoNo"),
      juchudenpyoNo: methods.watch("juchudenpyoNo"),
      tokuiNm: methods.watch("tokuiNm"),
      tokuiPostCd: methods.watch("tokuiPostCd"),
      tokuiAddress1: methods.watch("tokuiAddress1"),
      tokuiAddress2: methods.watch("tokuiAddress2"),
      tokuiTelNo: methods.watch("tokuiTelNo"),
      tokuiFaxNo: methods.watch("tokuiFaxNo"),
      nonyuNm: methods.watch("nonyuNm"),
      nonyuPostCd: methods.watch("nonyuPostCd"),
      nonyuAddress1: methods.watch("nonyuAddress1"),
      nonyuAddress2: methods.watch("nonyuAddress2"),
      nonyuTelNo: methods.watch("nonyuTelNo"),
      nonyuFaxNo: methods.watch("nonyuFaxNo"),
      ediMemo: methods.watch("ediMemo"),
      nonyuShokuchiKbn: methods.watch("nonyuShokuchiKbn"),
    };
  };

  const b020012Props: B020012Props = {
    editKbn: editKbn.update,
    fields: {},
    data: [],
    meiMethods: meiMethods,
  };

  // セット構成品の引数を設定(呼び出し)
  const getKoseiProps = () => {
    b020012Props.fields = {
      setshohinCd: meiMethods.watch("shohinCd"),
      setshohinNm: meiMethods.watch("shohinNm"),
      urisu: meiMethods.watch("urisu"),
      tokuiCd: methods.watch("tokuiCd"),
      uriYmd: methods.watch("uriYmd"),
      zeiRitsu: methods.watch("zeiRitsu"),
      tokuishitenCd: methods.watch("tokuishitenCd"),
      uriageSakuseiKbn: methods.watch("uriageSakuseiKbn"),
      zeimarumeKbn: methods.watch("zeimarumeKbn"),
      kinmarumeKbn: methods.watch("kinmarumeKbn"),
      tankamarumeKbn: methods.watch("tankamarumeKbn"),
      tankahasuichi: methods.watch("tankahasuichi"),
      zeiKbn: methods.watch("zeiKbn"),
      tankaKakeritsu: methods.watch("tankaKakeritsu"),
      uchiwakeKbn: meiMethods.watch("uchiwakeKbn")?.value,
      jodaihyojiKbn: methods.watch("jodaihyojiKbn"),
    };
    b020012Props.data = meiMethods.watch("koseiData")?.map((value) => ({
      uridenpyoNo: value.uridenpyoNo,
      urigyoNo: value.urigyoNo,
      urikoseigyoNo: value.urikoseigyoNo,
      juchudenpyoNo: value.juchudenpyoNo,
      juchugyoNo: value.juchugyoNo,
      juchukoseigyoNo: value.juchukoseigyoNo,
      shohinCd: value.shohinCd,
      shohinCdBefore: value.shohinCdBefore,
      janCd: value.janCd,
      aiteCd: value.aiteCd,
      shohinNm: value.shohinNm,
      vol: value.vol,
      sotosunW: value.sotosunW,
      sotosunH: value.sotosunH,
      uchisunW: value.uchisunW,
      uchisunH: value.uchisunH,
      koseisu: value.koseisu,
      hitsuyosu: value.hitsuyosu,
      hitsuyosuBefore: value.hitsuyosuBefore,
      kanosu: value.kanosu,
      jodaitanka: value.jodaitanka,
      uritanka: value.uritanka,
      kakeritsu: value.kakeritsu,
      uriKin: value.uriKin,
      sokoCd: value.sokoCd,
      sokoNm: value.sokoNm,
      sokoshubetsuKbn: value.sokoshubetsuKbn,
      meisaikoseiBikoCd: value.meisaikoseiBikoCd,
      meisaikoseiBiko: value.meisaikoseiBiko,
      kazeiKbn: value.kazeiKbn,
      tenyuryokujodaiKbn: value.tenyuryokujodaiKbn,
      tenyuryokuuriKbn: value.tenyuryokuuriKbn,
      basejodaitanka: value.basejodaitanka,
      baseuritanka: value.baseuritanka,
      shohinshubetsuKbn: value.shohinshubetsuKbn,
      tankaKbn: value.tankaKbn,
      shokuchiKbn: value.shokuchiKbn,
      whtankaCd: value.whtankaCd,
      setshohinKbn: value.setshohinKbn,
      zaikokanriKbn: value.zaikokanriKbn,
      crtDate: value.crtDate,
      crtshainCd: value.crtshainCd,
    }));

    return b020012Props;
  };

  // セット構成品の引数を設定(返却)
  const setKoseiProps = (b020012Props: B020012Props) => {
    const koseiDataList: KoseiData[] = [];

    // 売上数
    meiMethods.setValue("urisu", b020012Props.fields?.urisu);
    // 上代単価
    meiMethods.setValue("jodaitanka", b020012Props.fields?.setjodaitanka);
    // 下代単価
    meiMethods.setValue("uritanka", b020012Props.fields?.seturitanka);

    // 掛率の再計算
    const kakeritsu: string = getKakeritsu(
      b020012Props.fields?.seturitanka!,
      b020012Props.fields?.setjodaitanka!
    );
    meiMethods.setValue("kakeritsu", kakeritsu);

    // 売上金額の再計算
    handleCalcUriKin();

    if (Object.keys(b020012Props!.data!).length === 0) {
      meiMethods.setValue(
        "juchuSeisanhinKbn",
        getSCode(JuchuSeisanhinKbn, juchuSeisanhinKbn.nashi)
      );

      meiMethods.setValue("koseiData", koseiDataList);
      return;
    }

    // 構成品の中に受注生産品が含まれるかどうか
    const isJuchuSeisanhinKbn: boolean = b020012Props!.data!.some(
      (koseiData) =>
        koseiData.shohinshubetsuKbn === shohinshubetsuKbn.madeToOrder
    );

    meiMethods.setValue(
      "juchuSeisanhinKbn",
      getSCode(
        JuchuSeisanhinKbn,
        isJuchuSeisanhinKbn ? juchuSeisanhinKbn.ari : juchuSeisanhinKbn.nashi
      )
    );

    // 構成品データ
    for (let i: number = 0; i < b020012Props!.data!.length; i++) {
      const koseiData: KoseiData = {
        uridenpyoNo: b020012Props!.data![i].uridenpyoNo,
        urigyoNo: b020012Props!.data![i].urigyoNo,
        urikoseigyoNo: b020012Props!.data![i].urikoseigyoNo,
        juchudenpyoNo: b020012Props!.data![i].juchudenpyoNo,
        juchugyoNo: b020012Props!.data![i].juchugyoNo,
        juchukoseigyoNo: b020012Props!.data![i].juchukoseigyoNo,
        shohinCd: b020012Props!.data![i].shohinCd,
        shohinCdBefore: b020012Props!.data![i].shohinCdBefore,
        sokoCd: b020012Props!.data![i].sokoCd,
        shohinNm: b020012Props!.data![i].shohinNm,
        janCd: b020012Props!.data![i].janCd,
        aiteCd: b020012Props!.data![i].aiteCd,
        koseisu: b020012Props!.data![i].koseisu,
        hitsuyosu: b020012Props!.data![i].hitsuyosu,
        hitsuyosuBefore: b020012Props!.data![i].hitsuyosuBefore,
        kanosu: b020012Props!.data![i].kanosu,
        sokoNm: b020012Props!.data![i].sokoNm,
        sokoshubetsuKbn: b020012Props!.data![i].sokoshubetsuKbn,
        vol: b020012Props!.data![i].vol,
        sotosunW: b020012Props!.data![i].sotosunW,
        sotosunH: b020012Props!.data![i].sotosunH,
        uchisunW: b020012Props!.data![i].uchisunW,
        uchisunH: b020012Props!.data![i].uchisunH,
        tenyuryokujodaiKbn: b020012Props!.data![i].tenyuryokujodaiKbn,
        tenyuryokuuriKbn: b020012Props!.data![i].tenyuryokuuriKbn,
        basejodaitanka: b020012Props!.data![i].basejodaitanka,
        baseuritanka: b020012Props!.data![i].baseuritanka,
        jodaitanka: b020012Props!.data![i].jodaitanka,
        uritanka: b020012Props!.data![i].uritanka,
        kakeritsu: b020012Props!.data![i].kakeritsu,
        uriKin: b020012Props!.data![i].uriKin,
        meisaikoseiBikoCd: b020012Props!.data![i].meisaikoseiBikoCd,
        meisaikoseiBiko: b020012Props!.data![i].meisaikoseiBiko,
        kazeiKbn: b020012Props!.data![i].kazeiKbn,
        shohinshubetsuKbn: b020012Props!.data![i].shohinshubetsuKbn,
        tankaKbn: b020012Props!.data![i].tankaKbn,
        shokuchiKbn: b020012Props!.data![i].shokuchiKbn,
        whtankaCd: b020012Props!.data![i].whtankaCd,
        setshohinKbn: b020012Props!.data![i].setshohinKbn,
        zaikokanriKbn: b020012Props!.data![i].zaikokanriKbn,
        crtDate: b020012Props!.data![i].crtDate,
        crtshainCd: b020012Props!.data![i].crtshainCd,
      };

      koseiDataList.push(koseiData);
    }

    meiMethods.setValue("koseiData", koseiDataList);

    // 明細入力部に表示する可能数の設定
    let kanosu: string = "";
    // 構成品に可能数の設定されている行があるかチェック
    const isKanosu: boolean = koseiDataList.some(
      (koseiData: KoseiData) => koseiData.kanosu !== ""
    );
    // 可能数の設定されている行がある場合
    if (isKanosu) {
      kanosu = Math.min(
        ...koseiDataList
          .filter(function (kosei: KoseiData) {
            return kosei.kanosu !== "";
          })
          .map((kosei: KoseiData) => Number(kosei.kanosu))
      ).toString();
    }
    meiMethods.setValue("kanosu", kanosu);
    reRendering();
  };

  // レイアウト
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="売上入力"
          gridTemplateColumns="6rem 6rem 2rem 6rem 6rem 6rem 7rem 6rem 1rem 5rem 6rem 4rem 8rem 5rem 4rem"
        >
          <SInfoButton
            label={labels.buttons.supplement}
            {...register(29)}
            gridColumn={!isReference ? "-3" : "-1"}
            dialog={<B020011 {...getSupplementProps()} />}
            dialogAction="close"
            handleSubmit={(data: any) => {
              methods.setValue("nonyuNm", data.nonyuNm);
              methods.setValue("nonyuPostCd", data.nonyuPostCd);
              methods.setValue("nonyuAddress1", data.nonyuAddress1);
              methods.setValue("nonyuAddress2", data.nonyuAddress2);
              methods.setValue("nonyuTelNo", data.nonyuTelNo);
              methods.setValue("nonyuFaxNo", data.nonyuFaxNo);
              reRendering();
            }}
          />
          {!isReference && (
            <>
              {methods.getValues().uridenpyoNo === "" ? (
                <SNormalButton
                  label={labels.buttons.create}
                  {...register(30)}
                  onClick={() => handleOpenCreateConfirm()}
                />
              ) : (
                <SNormalButton
                  label={labels.buttons.update}
                  {...register(30)}
                  onClick={() => handleOpenUpdateConfirm()}
                />
              )}
            </>
          )}
          <SLabel gridColumn={1} required>
            伝票発行
          </SLabel>
          <SCodeSelect
            label="伝票発行"
            required
            name="uridenpyohakoKbn"
            options={DenpyoHakoKbn}
            gridColumn="span 2"
            disabled
          />
          <SLabel required>得意先</SLabel>
          <SNumberField
            label="得意先コード"
            name="tokuiCd"
            code
            size={6}
            required
            {...register(3)}
            onBlur={() => handleChangeTokui()}
            disabled={isReference}
          />
          <SNumberField
            label="得意先支店コード"
            name="tokuishitenCd"
            code
            size={4}
            required
            {...register(4)}
            onBlur={() => handleChangeTokui()}
            dialog={<B000150 torihikishuryoYmd={torihikishuryoYmd} />}
            handleSubmit={(data: any) => {
              methods.setValue("tokuiCd", data.tokuiCd);
              methods.setValue("tokuishitenCd", data.tokuishitenCd);
              methods.setValue("tokuiNm", data.tokuiNm1);

              // 得意先関連項目設定
              (async () => {
                await B020010Tokui(methods, navigate, setMsg);
                reRendering();
              })();
            }}
            disabled={isReference}
          />
          <STextField name="tokuiNm" disabled gridColumn="span 2" size={40} />
          <STextField name="shimeD" gridColumn="span 2" disabled />
          <SLabel>伝票種別</SLabel>
          <SNumberField
            name="denpyoshubetsuCd"
            {...register(15)}
            size={3}
            code
            onBlur={handleChangeDenpyoshubetsu}
            dialog={<B000111 meishoKbn={meishoKbn.denpyoshubetsu} />}
            handleSubmit={(data: any) => {
              methods.setValue("denpyoshubetsuCd", data?.meishoCd);
              methods.setValue("denpyoshubetsuNm", data?.meishoNm1);
              reRendering();
            }}
            disabled={isReference}
          />
          <STextField name="denpyoshubetsuNm" disabled />
          <SLabel>伝票区分</SLabel>
          <SNumberField
            name="denpyoKbn"
            {...register(20)}
            code
            disabled={isReference}
            size={3}
          />
          <SLabel gridColumn="1">売上No</SLabel>
          <SNumberField
            name="uridenpyoNo"
            disabled
            gridColumn="span 2"
            size={10}
            code
          />
          <SLabel required>売上担当者</SLabel>
          <SNumberField
            label="売上担当者"
            name="shainCd"
            code
            size={7}
            required
            {...register(5)}
            onBlur={handleChangeShain}
            dialog={
              <B000140
                eigyoCd={methods.watch("eigyoCd")}
                bumonCd={methods.watch("bumonCd")}
              />
            }
            handleSubmit={(data: any) => {
              methods.setValue("shainCd", data.shainCd);
              methods.setValue("shainNm", data.shainNm);
              methods.setValue("bumonCd", data.bumonCd);
              methods.setValue("bumonNm", data.bumonNm);
              methods.setValue("eigyoCd", data.eigyoCd);
              reRendering();
            }}
            gridColumn="span 2"
            disabled={isReference}
          />
          <STextField name="shainNm" disabled gridColumn="span 4" />
          <SLabel>添付伝票</SLabel>
          <STextField
            name="tenpudenpyoCd"
            code
            size={3}
            {...register(16)}
            onBlur={handleChangeTenpudenpyo}
            dialog={
              <B000111
                meishoKbn={meishoKbn.tenpudenpyo}
                denpyoshubetsuCd={methods.watch("denpyoshubetsuCd")}
              />
            }
            handleSubmit={(data: any) => {
              methods.setValue("tenpudenpyoCd", data?.meishoCd);
              methods.setValue("tenpudenpyoNm", data?.meishoNm1);
              reRendering();
            }}
            disabled={isReference || isTenpudenpyoCdDisabled}
          />
          <STextField name="tenpudenpyoNm" disabled />
          <SLabel>率</SLabel>
          <STextField
            name="ritsu"
            {...register(21)}
            size={6}
            disabled={isReference}
          />
          <SLabel gridColumn="1">専用伝票No</SLabel>
          <STextField
            name="senyodenpyoNo"
            gridColumn="span 2"
            size={10}
            {...register(1)}
            disabled={isReference}
          />
          <SLabel required>納入先</SLabel>
          <SNumberField
            label="納入先コード"
            name="nonyuCd"
            code
            size={6}
            required
            {...register(6)}
            onBlur={() => handleChangeNonyu()}
            disabled={isReference}
          />
          <SNumberField
            label="納入先支店コード"
            name="nonyushitenCd"
            code
            size={4}
            required
            {...register(7)}
            onBlur={() => handleChangeNonyu()}
            dialog={
              <B000151
                tokuiCd={methods.watch("tokuiCd")}
                tokuishitenCd={methods.watch("tokuishitenCd")}
                torihikishuryoYmd={torihikishuryoYmd}
              />
            }
            handleSubmit={(data: any) => {
              methods.setValue("nonyuCd", data.nonyuCd);
              methods.setValue("nonyushitenCd", data.nonyushitenCd);
              methods.setValue("nonyuNm", data.tokuiNm1);

              // 納入関連項目設定
              (async () => {
                await B010010Nonyu(methods, navigate, setMsg);
                reRendering();
              })();
            }}
            disabled={isReference}
          />
          <STextField
            name="nonyuNm"
            {...register(8)}
            size={40}
            disabled={!isNonyuShokuchi || isReference}
            gridColumn="span 4"
          />
          <SLabel>分類</SLabel>
          <STextField
            name="bunrui"
            {...register(17)}
            size={4}
            disabled={isReference}
          />
          <SLabel gridColumn="1">受注No</SLabel>
          <SNumberField
            name="juchudenpyoNo"
            code
            size={10}
            gridColumn="span 2"
            disabled
          />
          <SLabel required>伝票日付</SLabel>
          <SDateField
            required
            label="伝票日付"
            name="uriYmd"
            {...register(9)}
            gridColumn="span 2"
            onBlur={() => handleChangeUriYmd()}
            onAccept={(date: string) => {
              handleChangeUriYmd(date);
            }}
            disabled={isReference}
          />
          <SLabel gridColumn="11">運送会社</SLabel>
          <STextField
            name="unsogaishaCd"
            {...register(18)}
            code
            size={4}
            onBlur={handleChangeUnsogaisha}
            dialog={<B000111 meishoKbn={meishoKbn.unsogaisha} />}
            handleSubmit={(data: any) => {
              methods.setValue("unsogaishaCd", data?.meishoCd);
              methods.setValue("unsogaishaNm", data?.meishoNm1);
              reRendering();
            }}
            disabled={isReference}
          />
          <STextField name="unsogaishaNm" disabled gridColumn="span 3" />
          <SLabel gridColumn="1" required>
            売上区分
          </SLabel>
          <SCodeSelect
            name="uriageKbn"
            options={ChohaKbn}
            gridColumn="span 2"
            {...register(2)}
            disabled={isReference}
          />
          <SLabel>必着日</SLabel>
          <SDateField
            name="shukaYmd"
            {...register(10)}
            gridColumn="span 2"
            disabled={isReference}
          />
          <SLabel required>請求書発行</SLabel>
          <SCodeSelect
            label="請求書発行"
            name="seikyushokisaiKbn"
            {...register(13)}
            options={SeikyusyoHakoKbn}
            gridColumn="span 3"
            required
            disabled={isReference}
          />
          <SLabel>売上担当部門</SLabel>
          <STextField name="bumonCd" disabled size={6} />
          <STextField name="bumonNm" disabled gridColumn="span 3" />
          <SLabel gridColumn="4" required>
            発送先
          </SLabel>
          <SCodeSelect
            label="発送先"
            name="hasosakiCd"
            {...register(11)}
            options={HasosakiCd}
            gridColumn="span 2"
            disabled={isReference}
          />
          <SLabel>消費税区分</SLabel>
          <SCodeSelect
            name="zeiKbnView"
            options={ZeiKbn}
            disabled
            gridColumn="span 3"
          />
          <SLabel>客先No.</SLabel>
          <STextField
            name="chumonNo"
            {...register(19)}
            size={10}
            gridColumn="span 2"
            disabled={isReference}
          />
          <SLabel gridColumn="4" required>
            発送区分
          </SLabel>
          <SCodeSelect
            label="発送区分"
            name="hasokbnCd"
            {...register(12)}
            options={HasokbnCd}
            gridColumn="span 2"
            disabled={isReference}
          />
          <SLabel required>アシスタント</SLabel>
          <STextField
            name="assistantCd"
            code
            size={7}
            required
            label="アシスタント"
            {...register(14)}
            onBlur={handleChangeAssistant}
            dialog={
              <B000140
                bumonCd={methods.watch("bumonCd")}
                eigyoCd={methods.watch("eigyoCd")}
              />
            }
            handleSubmit={(data: any) => {
              methods.setValue("assistantCd", data.shainCd);
              methods.setValue("assistantNm", data.shainNm);
              reRendering();
            }}
            disabled={isReference}
          />
          <STextField name="assistantNm" disabled gridColumn="span 2" />

          <SText gridColumn="1">　</SText>

          <SLabel gridColumn="1">品別番号</SLabel>
          <STextField
            name="hinbetsuNo"
            {...register(22)}
            size={10}
            gridColumn="span 2"
            disabled={isReference}
          />
          <SLabel>納品先</SLabel>
          <STextField
            name="nohinsaki"
            {...register(26)}
            size={20}
            gridColumn="span 2"
            disabled={isReference}
          />
          <SLabel>売場名</SLabel>
          <STextField
            name="uribaNm"
            {...register(27)}
            gridColumn="span 3"
            size={16}
            disabled={isReference}
          />
          <SLabel>内線</SLabel>
          <STextField
            name="naisen"
            {...register(28)}
            gridColumn="span 2"
            size={13}
            disabled={isReference}
          />
          <SLabel gridColumn="1">担当者</SLabel>
          <STextField
            name="tantosha"
            {...register(23)}
            gridColumn="span 2"
            size={16}
            disabled={isReference}
          />
          <SLabel gridColumn="1">売上備考</SLabel>
          <SNumberField
            name="bikoCd"
            code="true"
            size={3}
            gridColumn="span 2"
            {...register(24)}
            onBlur={handleChangeBiko}
            dialog={<B000111 meishoKbn={meishoKbn.biko} />}
            handleSubmit={(data: any) => {
              methods.setValue("bikoCd", data?.meishoCd);
              methods.setValue("biko", data?.meishoNm1);
              methods.setValue("bikoCdBefore", data?.meishoCd);
              reRendering();
            }}
            disabled={isReference}
          />
          <STextField
            name="biko"
            {...register(25)}
            gridColumn="span 3"
            size={40}
            disabled={isReference}
          />

          <Box display="grid" gridColumn="span 4 / 15" gridRow="span 2">
            <Box display="grid" gridTemplateColumns="8em 8em 8em">
              <SLabel>売上金額合計</SLabel>
              <SLabel>消費税</SLabel>
              <SLabel>伝票合計</SLabel>
              <SNumberField
                name="uriKinGokei"
                disabled
                size={9}
                align="right"
              />
              <SNumberField name="zeiGokei" disabled size={9} align="right" />
              <SNumberField
                name="denpyoGokei"
                disabled
                size={9}
                align="right"
              />
            </Box>
          </Box>
        </SFrame>
      </FormProvider>
      <SFrame>
        <STable
          keyName="urigyoNo"
          data={rows}
          columns={columns}
          totalCount={rowCount}
          tableRef={tableRef}
          width="78rem"
          height={isReference ? "25rem" : "10rem"}
          pageSize={20}
          handleDoubleClick={
            isReference ? undefined : handleDoubleClickTableRow
          }
          rowSelectable={meiMethods.watch("meiTab")}
        />
      </SFrame>
      {isReference ? (
        <></>
      ) : (
        <FormProvider {...meiMethods}>
          <SFrame>
            <SEntryTab
              name="meiTab"
              handleOk={() => {
                handleChangeMeiTab();
              }}
            ></SEntryTab>
            <SFrame
              gridTemplateColumns="8rem 10rem 4rem 10rem 8rem 9rem 9rem 9rem 9rem"
              columnGap="3px"
              rowGap="2px"
            >
              <SLabel required>内訳区分</SLabel>
              <SLabel required gridColumn="span 2">
                商品コード
              </SLabel>
              <SLabel>JANコード</SLabel>
              <SLabel>WH(外)</SLabel>
              <SLabel>WH(内)</SLabel>
              <SLabel>可能数</SLabel>
              <SLabel>上代</SLabel>
              <SLabel required>掛率</SLabel>
              <SCodeSelect
                label="内訳区分"
                name="uchiwakeKbn"
                required
                {...register(31)}
                options={UriageUchiwakeKbn}
                onChange={() => handleChangeUchiwakeKbn()}
              />
              <SNumberField
                label="商品コード"
                name="shohinCd"
                code
                size={10}
                required
                {...register(32)}
                onBlur={handleChangeShohinCd}
                disabled={isMeiDisabled}
                dialog={<B000200 />}
                handleSubmit={(data: any) => {
                  meiMethods.setValue("shohinCd", data.shohinCd);
                  meiMethods.setValue("janCd", data.janCd);
                  meiMethods.setValue("shohinNm", data.shohinNm);
                  (async () => {
                    // 商品関連項目設定
                    await B020010Shohin(methods, meiMethods, navigate, setMsg);
                    reRendering();
                  })();
                }}
              />
              <SInfoButton
                label={labels.buttons.component}
                {...register(33)}
                disabled={isKoseiDisabled}
                dialog={<B020012 {...getKoseiProps()} />}
                dialogAction="close"
                handleSubmit={(data: any) => {
                  setKoseiProps(data);
                }}
              />
              <STextField
                name="janCd"
                {...register(34)}
                size={13}
                onBlur={handleChangeJanCd}
                disabled={isMeiDisabled}
                dialog={<B000200 />}
                handleSubmit={(data: any) => {
                  meiMethods.setValue("shohinCd", data.shohinCd);
                  meiMethods.setValue("janCd", data.janCd);
                  meiMethods.setValue("shohinNm", data.shohinNm);
                  (async () => {
                    // 商品関連項目設定
                    await B020010Shohin(methods, meiMethods, navigate, setMsg);
                    reRendering();
                  })();
                }}
              />

              <Box display="grid" gridTemplateColumns="3em auto 3em">
                <SNumberField
                  name="sotosunW"
                  {...register(38)}
                  onBlur={handleChangeWhTanka}
                  size={5}
                  disabled={isMeiDisabled}
                />
                <SText>✕</SText>
                <SNumberField
                  name="sotosunH"
                  {...register(39)}
                  onBlur={handleChangeWhTanka}
                  size={5}
                  disabled={isMeiDisabled}
                />
              </Box>
              <Box display="grid" gridTemplateColumns="3em auto 3em">
                <SNumberField
                  name="uchisunW"
                  {...register(40)}
                  size={5}
                  disabled={isMeiDisabled}
                />
                <SText>✕</SText>
                <SNumberField
                  name="uchisunH"
                  {...register(41)}
                  size={5}
                  disabled={isMeiDisabled}
                />
              </Box>

              <SNumberField name="kanosu" disabled />
              <SNumberField
                name="jodaitanka"
                {...register(43)}
                size={9}
                onBlur={() => {
                  handleCalcUritankaUriKin();
                }}
                disabled={isMeiDisabled || isSetshohinKbn}
              />
              <SNumberField
                name="kakeritsu"
                required
                label="掛率"
                {...register(45)}
                size={6}
                onBlur={() => {
                  handleCalcUritankaUriKin();
                }}
                disabled={isMeiDisabled || isSetshohinKbn}
              />

              <SLabel gridColumn="2/4">受注生産品</SLabel>
              <SLabel gridColumn="span 2">商品名</SLabel>
              <SLabel required>売上数</SLabel>
              <SLabel>課税</SLabel>
              <SLabel required>下代</SLabel>
              <SLabel required>金額</SLabel>
              <Box display="grid" gridColumn="2/4">
                <SCodeSelect
                  name="juchuSeisanhinKbn"
                  disabled
                  options={JuchuSeisanhinKbn}
                />
              </Box>
              <STextField
                name="shohinNm"
                {...register(35)}
                size={40}
                gridColumn="span 2"
                disabled={isMeiDisabled || !isShohinShokuchiKbn}
              />

              {/* 値引きが選択されている場合、受注数は空を表示 */}
              {isUchiwakeNebiki ? (
                <STextField
                  name="nebikiUrisu"
                  {...register(42)}
                  disabled
                  size={6}
                />
              ) : (
                <SNumberField
                  required
                  name="urisu"
                  label="売上数"
                  {...register(42)}
                  size={6}
                  onBlur={() => handleChangeUrisu()}
                  disabled={isMeiDisabled}
                  dialog={
                    !isMeiJuchuSeisanhin && !isSetshohinKbn ? (
                      <B000220 shohinCd={meiMethods.watch("shohinCd")} />
                    ) : undefined
                  }
                  handleSubmit={
                    !isMeiJuchuSeisanhin && !isSetshohinKbn
                      ? (data: any) => {
                          meiMethods.setValue("shohinCd", data.shohinCd);
                          meiMethods.setValue("janCd", data.janCd);
                          meiMethods.setValue("shohinNm", data.shohinNm);
                          meiMethods.setValue("sokoCd", data.sokoCd);
                          meiMethods.setValue("sokoNm", data.sokoNm);
                          meiMethods.setValue("kanosu", data.zaikosu);
                          meiMethods.setValue(
                            "sokoshubetsuKbn",
                            data.sokoshubetsuKbn
                          );
                          // 商品関連項目設定
                          (async () => {
                            await B020010ShohinZaiko(
                              methods,
                              meiMethods,
                              navigate,
                              setMsg
                            );
                            reRendering();
                          })();
                        }
                      : undefined
                  }
                />
              )}

              <STextField name="kazeiKbnView" disabled />
              <SNumberField
                required
                name="uritanka"
                label="下代"
                {...register(44)}
                size={9}
                onBlur={handleCalcJuchuKinFromUritanka}
                disabled={isMeiDisabled || isSetshohinKbn}
              />
              <SNumberField
                required
                name="uriKin"
                label="金額"
                {...register(46)}
                size={9}
                disabled={isMeiDisabled || isKingakuDisabled || isSetshohinKbn}
              />
              <SLabel gridColumn="2/5" required>
                倉庫
              </SLabel>
              <SLabel>相手コード</SLabel>
              <SLabel>VOL</SLabel>
              <SLabel gridColumn="7/10">売上明細備考</SLabel>
              <Box
                display="grid"
                gridColumn="2/5"
                gridTemplateColumns="4em 1fr"
              >
                {/* 倉庫コードは、条件によって必須ではなくなるためrequiredを設定しない */}
                <STextField
                  name="sokoCd"
                  {...register(36)}
                  size={3}
                  onBlur={() => handleChangeSokoCd()}
                  disabled={isMeiDisabled}
                  dialog={<B000190 />}
                  handleSubmit={(data: any) => {
                    meiMethods.setValue("sokoCd", data?.sokoCd);
                    meiMethods.setValue("sokoNm", data?.sokoNm);
                    meiMethods.setValue(
                      "sokoshubetsuKbn",
                      data?.sokoshubetsuKbn
                    );
                    // 引当可能数取得処理
                    (async () => {
                      await B020010Kanosu(
                        methods,
                        meiMethods,
                        navigate,
                        setMsg
                      );
                      reRendering();
                    })();
                  }}
                />
                <STextField name="sokoNm" disabled gridColumn="2/3" />
              </Box>
              <STextField
                name="aiteCd"
                {...register(37)}
                size={20}
                disabled={isMeiDisabled}
              />
              <STextField name="vol" disabled />
              <Box
                display="grid"
                gridColumn="7/10"
                gridTemplateColumns="4em 1fr"
              >
                <SNumberField
                  code
                  name="meisaibikoCd"
                  {...register(47)}
                  size={3}
                  onBlur={() => B000111Meisaibiko(meiMethods, navigate, setMsg)}
                  disabled={isMeiDisabled}
                  dialog={<B000111 meishoKbn="7" />}
                  handleSubmit={(data: any) => {
                    meiMethods.setValue("meisaibikoCd", data?.meishoCd);
                    meiMethods.setValue("meisaibikoCdBefore", data?.meishoCd);
                    meiMethods.setValue("meisaibiko", data?.meishoNm1);
                    reRendering();
                  }}
                />
                <STextField
                  name="meisaibiko"
                  {...register(48)}
                  size={30}
                  disabled={isMeiDisabled}
                />
              </Box>
              {!meiMethods.watch("meiTab") && (
                <SCancelButton
                  label={labels.buttons.deleteDetail}
                  gridRow="7"
                  gridColumn="1"
                  onClick={handleClickDeleteMeiButton}
                />
              )}
              {meiMethods.watch("meiTab") ? (
                <SNormalButton
                  label={labels.buttons.createDetail}
                  {...register(49)}
                  gridRow="7"
                  gridColumn="9"
                  align="right"
                  onClick={handleClickCreateMeiButton}
                />
              ) : (
                <SNormalButton
                  label={labels.buttons.updateDetail}
                  {...register(49)}
                  gridRow="7"
                  gridColumn="9"
                  align="right"
                  onClick={handleClickUpdateMeiButton}
                />
              )}
            </SFrame>
          </SFrame>
          <SConfirmDialogAction
            msg={labels.dialog.createCheck}
            onOk={handleClickCreateButton}
            onCancel={handleCancelCreateConfirm}
            isOpen={openCreateConfirm}
          />
          <SConfirmDialogAction
            msg={labels.dialog.updateCheck}
            onOk={handleClickUpdateButton}
            onCancel={handleCancelUpdateConfirm}
            isOpen={openUpdateConfirm}
          />
        </FormProvider>
      )}
    </>
  );
};
